(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-expand"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('announcement-expand')) return;

    class AnnouncementExpand extends HTMLElement {
      connectedCallback() {
        this.panel = this.querySelector('.announcement-expand__panel');
        this.backdrop = this.querySelector('[data-backdrop]');
        this.toggles = Array.from(this.querySelectorAll('[data-toggle]'));
        this.messages = Array.from(this.querySelectorAll('.announcement-expand__message'));
        this.msgIndex = 0;
        this.timer = null;
        this.interval = parseInt(this.dataset.interval, 10) || 4000;
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.rotate = this.dataset.rotate === 'true' && this.messages.length > 1 && !reducedMotion;

        this.toggles.forEach((btn) => btn.addEventListener('click', () => this.togglePanel()));
        if (this.backdrop) this.backdrop.addEventListener('click', () => this.closePanel());
        const closeBtn = this.querySelector('[data-close]');
        if (closeBtn) closeBtn.addEventListener('click', () => this.closePanel());
        document.addEventListener('keydown', (e) => {
          if (e.key === 'Escape') this.closePanel();
        });

        const prev = this.querySelector('[data-msg-prev]');
        const next = this.querySelector('[data-msg-next]');
        if (prev) prev.addEventListener('click', () => this.goMsg(this.msgIndex - 1, true));
        if (next) next.addEventListener('click', () => this.goMsg(this.msgIndex + 1, true));

        const bar = this.querySelector('.announcement-expand__bar');
        if (bar) {
          bar.addEventListener('mouseenter', () => this.stopRotate());
          bar.addEventListener('mouseleave', () => this.startRotate());
          bar.addEventListener('focusin', () => this.stopRotate());
          bar.addEventListener('focusout', () => this.startRotate());
        }

        const copyBtn = this.querySelector('[data-copy]');
        if (copyBtn) {
          const label = copyBtn.querySelector('[data-copy-text]');
          const original = label.textContent;
          copyBtn.addEventListener('click', () => {
            const code = copyBtn.dataset.code;
            const done = () => {
              label.textContent = copyBtn.dataset.copiedLabel;
              clearTimeout(this.copyTimer);
              this.copyTimer = setTimeout(() => {
                label.textContent = original;
              }, 2000);
            };
            if (navigator.clipboard && navigator.clipboard.writeText) {
              navigator.clipboard.writeText(code).then(done).catch(done);
            } else {
              const tmp = document.createElement('textarea');
              tmp.value = code;
              document.body.appendChild(tmp);
              tmp.select();
              try {
                document.execCommand('copy');
              } catch (err) {
                /* sem clipboard disponível — o código segue visível para cópia manual */
              }
              document.body.removeChild(tmp);
              done();
            }
          });
        }

        this.goMsg(0);
        this.startRotate();
      }

      goMsg(rawIndex, fromUser) {
        const count = this.messages.length;
        if (!count) return;
        this.msgIndex = ((rawIndex % count) + count) % count;
        this.messages.forEach((msg, i) => {
          const active = i === this.msgIndex;
          msg.classList.toggle('is-active', active);
          if (msg.tagName === 'A' || msg.tagName === 'BUTTON') {
            if (active) msg.removeAttribute('tabindex');
            else msg.setAttribute('tabindex', '-1');
          }
        });
        if (fromUser && this.rotate) {
          this.stopRotate();
          this.startRotate();
        }
      }

      startRotate() {
        if (!this.rotate || this.timer || this.classList.contains('is-open')) return;
        this.timer = setInterval(() => this.goMsg(this.msgIndex + 1), this.interval);
      }

      stopRotate() {
        if (!this.timer) return;
        clearInterval(this.timer);
        this.timer = null;
      }

      togglePanel() {
        if (this.classList.contains('is-open')) this.closePanel();
        else this.openPanel();
      }

      openPanel() {
        this.classList.add('is-open');
        this.toggles.forEach((btn) => btn.setAttribute('aria-expanded', 'true'));
        if (this.panel) this.panel.setAttribute('aria-hidden', 'false');
        this.stopRotate();
      }

      closePanel() {
        if (!this.classList.contains('is-open')) return;
        this.classList.remove('is-open');
        this.toggles.forEach((btn) => btn.setAttribute('aria-expanded', 'false'));
        if (this.panel) this.panel.setAttribute('aria-hidden', 'true');
        this.startRotate();
      }
    }

    customElements.define('announcement-expand', AnnouncementExpand);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  (() => {
    const drawer = document.getElementById('cart-drawer');
    if (!drawer) return;

    const changeUrl = drawer.dataset.cartChangeUrl;
    const updateUrl = drawer.dataset.cartUpdateUrl;
    const cartUrl = drawer.dataset.cartUrl;
    let lastFocus = null;

    const openDialog = () => {
      lastFocus = document.activeElement;
      if (typeof drawer.showModal === 'function') {
        drawer.showModal();
      } else {
        drawer.setAttribute('open', '');
      }
    };

    const open = () => {
      openDialog();
      refresh();
    };

    const close = () => {
      if (typeof drawer.close === 'function') {
        drawer.close();
      } else {
        drawer.removeAttribute('open');
      }
      if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
    };

    // Open from any cart-icon trigger (header). Progressive enhancement:
    // without JS the <a href="/cart"> just navigates.
    document.addEventListener('click', (event) => {
      const opener = event.target.closest('[data-action="open-cart"]');
      if (!opener) return;
      event.preventDefault();
      open();
    });

    // Allow other components (e.g. the PDP add-to-cart form) to open the drawer.
    // If the dispatcher passes freshly rendered section HTML, use it directly to
    // avoid an extra fetch; otherwise open and refresh from the server.
    document.addEventListener('cart:open', (event) => {
      const detail = event.detail || {};
      const sections = detail.sections;
      if (sections && replaceContent(sections['cart-drawer'])) {
        openDialog();
      } else {
        open();
      }
    });

    // The prazo estimator (snippets/prazo-estimator.liquid) dispatches this when a
    // delivery quote is computed or a carrier is chosen in the modal. Reflect the
    // chosen price into the summary's Entrega + Total rows (estimate only — the
    // real shipping is charged at checkout). Listener on document so it survives
    // the drawer's content re-render.
    document.addEventListener('prazo:selected', (event) => {
      const detail = event.detail || {};
      if (typeof detail.priceCents !== 'number') return;
      const deliveryEl = drawer.querySelector('[data-summary-delivery]');
      const totalEl = drawer.querySelector('[data-summary-total]');
      const totalValueEl = drawer.querySelector('[data-summary-total-value]');
      if (!deliveryEl || !totalEl || !totalValueEl) return;
      const formatter = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' });
      const cartTotalCents = parseInt(totalEl.getAttribute('data-cart-total-cents') || '0', 10);
      const grandTotalCents = cartTotalCents + detail.priceCents;
      // Update only the value span, keeping the row label/structure intact.
      deliveryEl.textContent = formatter.format(detail.priceCents / 100);
      totalValueEl.textContent = formatter.format(grandTotalCents / 100);
      // Recompute installments under the same rule as the PDP/cards: up to the max
      // cap, with a R$90 (9000-cent) minimum per installment — the grand total shifts
      // when a delivery quote is added, so the COUNT (not just the per-value) changes.
      const installmentEl = drawer.querySelector('[data-summary-installment]');
      if (installmentEl) {
        const maxInstallments = parseInt(installmentEl.getAttribute('data-installments-max') || '1', 10) || 1;
        const installmentCount = Math.max(1, Math.min(maxInstallments, Math.floor(grandTotalCents / 9000)));
        if (installmentCount <= 1) {
          installmentEl.hidden = true;
        } else {
          installmentEl.hidden = false;
          const perInstallment = formatter.format((grandTotalCents / installmentCount) / 100);
          const template = installmentEl.getAttribute('data-installment-tpl') || '';
          if (template) installmentEl.textContent = template.replace('__COUNT__', installmentCount).replace('__PRICE__', perInstallment);
        }
      }
    });

    // Collapsed/expanded state of the order-summary breakdown. Starts collapsed
    // (matching the server-rendered markup) and lives in the closure — not the
    // DOM — so it survives replaceContent() re-rendering the whole card.
    let summaryCollapsed = true;

    function applySummaryState() {
      const details = drawer.querySelector('[data-summary-details]');
      const toggle = drawer.querySelector('[data-action="toggle-summary"]');
      if (!details || !toggle) return;
      details.hidden = summaryCollapsed;
      toggle.setAttribute('aria-expanded', summaryCollapsed ? 'false' : 'true');
    }

    // Single delegated handler on the persistent <dialog>. Survives content
    // re-render because the dialog element itself is never replaced.
    drawer.addEventListener('click', (event) => {
      if (event.target === drawer) {
        close();
        return;
      }
      const trigger = event.target.closest('[data-action]');
      if (!trigger || !drawer.contains(trigger)) return;
      switch (trigger.dataset.action) {
        case 'close-cart':
          event.preventDefault();
          close();
          break;
        case 'increase':
        case 'decrease':
        case 'remove':
          handleQuantity(trigger);
          break;
        case 'toggle-details':
          event.preventDefault();
          toggleDetails(trigger);
          break;
        case 'toggle-summary':
          event.preventDefault();
          summaryCollapsed = !summaryCollapsed;
          applySummaryState();
          break;
        default:
          break;
      }
    });

    // Expand/collapse a line item's product details (icon attrs + add-ons + edit link).
    function toggleDetails(trigger) {
      const item = trigger.closest('.cart-item');
      if (!item) return;
      const open = item.classList.toggle('is-open');
      trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
    }

    // Refresh drawer content from the server (covers cross-tab changes on open).
    async function refresh() {
      try {
        const res = await fetch(`${cartUrl}?sections=cart-drawer`, {
          headers: { Accept: 'application/json' }
        });
        if (!res.ok) return;
        const data = await res.json();
        replaceContent(data['cart-drawer']);
      } catch (err) {
        /* non-fatal: keep the server-rendered content already in the DOM */
      }
    }

    // Parse a rendered cart-drawer section string and swap the live content +
    // counts. The <dialog> itself is preserved (open state, focus, scroll).
    function replaceContent(html) {
      if (!html) return false;
      const parsed = new DOMParser().parseFromString(html, 'text/html');
      const newContent = parsed.querySelector('.cart-drawer__content');
      const current = drawer.querySelector('.cart-drawer__content');
      if (!newContent || !current) return false;
      current.replaceWith(newContent);
      applySummaryState();
      const newCount = parsed.querySelector('[data-cart-count]');
      if (newCount) updateCounts(newCount.textContent.trim());
      return true;
    }

    function updateCounts(count) {
      const value = String(count);
      const isZero = value === '0' || value === '';
      document.querySelectorAll('[data-cart-count]').forEach((el) => {
        el.textContent = value;
        if (el.classList.contains('site-header__cart-badge')) {
          el.toggleAttribute('hidden', isZero);
        }
      });
    }

    async function handleQuantity(trigger) {
      const li = trigger.closest('[data-cart-item]');
      if (!li) return;
      // Removing a grouped (personalized) album removes its add-ons too — but an
      // add-on chip (which also carries data-group) must remove only its own line.
      if (trigger.dataset.action === 'remove' && li.dataset.group && !li.dataset.addon) {
        const group = li.dataset.group;
        const keys = Array.from(drawer.querySelectorAll('[data-cart-item]'))
          .filter((el) => el.dataset.group === group)
          .map((el) => el.dataset.key);
        return removeGroup(li, keys);
      }
      const key = li.dataset.key;
      const valueEl = li.querySelector('[data-qty-value]');
      const current = parseInt(valueEl ? valueEl.textContent : '0', 10) || 0;
      let quantity = current;
      if (trigger.dataset.action === 'increase') quantity = current + 1;
      else if (trigger.dataset.action === 'decrease') quantity = Math.max(0, current - 1);
      else quantity = 0; // remove

      li.setAttribute('aria-busy', 'true');
      hideError();
      try {
        const res = await fetch(changeUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            id: key,
            quantity,
            sections: 'cart-drawer',
            sections_url: window.location.pathname
          })
        });
        if (!res.ok) throw new Error('change failed');
        const data = await res.json();
        const ok = replaceContent(data.sections && data.sections['cart-drawer']);
        if (!ok) {
          // Section payload missing/malformed -> last-resort fallback.
          window.location.assign(cartUrl);
        }
      } catch (err) {
        li.setAttribute('aria-busy', 'false');
        showError();
      }
    }

    async function removeGroup(li, keys) {
      li.setAttribute('aria-busy', 'true');
      hideError();
      const updates = {};
      keys.forEach((k) => { updates[k] = 0; });
      try {
        const res = await fetch(updateUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ updates, sections: 'cart-drawer', sections_url: window.location.pathname })
        });
        if (!res.ok) throw new Error('update failed');
        const data = await res.json();
        const ok = replaceContent(data.sections && data.sections['cart-drawer']);
        if (!ok) window.location.assign(cartUrl);
      } catch (err) {
        li.setAttribute('aria-busy', 'false');
        showError();
      }
    }

    function showError() {
      const el = drawer.querySelector('[data-cart-error]');
      if (!el) return;
      el.textContent = el.dataset.errorGeneric;
      el.hidden = false;
    }

    function hideError() {
      const el = drawer.querySelector('[data-cart-error]');
      if (el) el.hidden = true;
    }

    // Deep-link open: the retired /cart page redirects here as `/?cart=open`
    // (sections/cart.liquid). Open the drawer on load, then strip the param so a
    // later refresh or a shared/copied URL doesn't re-open it.
    const params = new URLSearchParams(window.location.search);
    if (params.get('cart') === 'open') {
      open();
      params.delete('cart');
      const query = params.toString();
      const cleanUrl = window.location.pathname + (query ? `?${query}` : '') + window.location.hash;
      window.history.replaceState({}, '', cleanUrl);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["categoria-adicionais"]) return;
  try {
    
  (function () {
    document.querySelectorAll('.categoria-adicionais').forEach(function (root) {
      const tabs = root.querySelectorAll('[data-adicionais-tab]');
      const dots = root.querySelectorAll('[data-adicionais-dot]');
      const panes = root.querySelectorAll('[data-adicionais-pane]');
      const heading = root.querySelector('[data-adicionais-heading]');
      const body = root.querySelector('[data-adicionais-body]');
      const cta = root.querySelector('[data-adicionais-cta]');

      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          const idx = tab.dataset.adicionaisTab;

          tabs.forEach(function (t) {
            const active = t === tab;
            t.classList.toggle('is-active', active);
            t.setAttribute('aria-selected', active ? 'true' : 'false');
          });

          dots.forEach(function (d) {
            d.classList.toggle('is-active', d.dataset.adicionaisDot === idx);
          });

          panes.forEach(function (pane) {
            const isActive = pane.dataset.adicionaisPane === idx;
            pane.classList.toggle('is-active', isActive);
            // Autoplay doesn't fire on a pane that was display:none at load, so
            // drive play/pause on switch. Reset inactive panes to the first frame.
            const paneVideo = pane.querySelector('video');
            if (paneVideo) {
              if (isActive) {
                paneVideo.play().catch(function () {});
              } else {
                paneVideo.pause();
                paneVideo.currentTime = 0;
              }
            }
          });

          if (heading) heading.textContent = tab.dataset.label || '';
          if (body) body.textContent = tab.dataset.body || '';
          if (cta) {
            const text = tab.dataset.ctaText || '';
            const url = tab.dataset.ctaUrl || '';
            cta.textContent = text;
            cta.href = url || '#';
            cta.hidden = !(text && url);
          }
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["categoria-product-grid"]) return;
  try {
    
  (function () {
    if (window.__categoriaGridInit) return;
    window.__categoriaGridInit = true;

    var inflightController = null;
    var inflightTimer = null;

    // ---- Price slider helpers ----

    function updatePriceVisual(slider) {
      var boundMin = parseFloat(slider.dataset.boundMin) || 0;
      var boundMax = parseFloat(slider.dataset.boundMax) || 0;
      if (boundMax <= boundMin) return;
      var minInput = slider.querySelector('[data-price-input-min]');
      var maxInput = slider.querySelector('[data-price-input-max]');
      var range    = slider.querySelector('[data-price-range]');
      var labelMin = slider.querySelector('[data-price-label-min]');
      var labelMax = slider.querySelector('[data-price-label-max]');
      if (!minInput || !maxInput || !range) return;

      var vmin = parseFloat(minInput.value);
      var vmax = parseFloat(maxInput.value);
      var leftPct  = ((vmin - boundMin) / (boundMax - boundMin)) * 100;
      var rightPct = ((vmax - boundMin) / (boundMax - boundMin)) * 100;
      range.style.left  = leftPct + '%';
      range.style.width = Math.max(0, rightPct - leftPct) + '%';
      if (labelMin) labelMin.textContent = 'R$ ' + Math.round(vmin);
      if (labelMax) labelMax.textContent = 'R$ ' + Math.round(vmax);
    }

    // Pattern from tmp/a.js: clamp each side strictly against the other on
    // every input event, so neither thumb can cross past its partner.
    function clampPrices(slider, changedSide) {
      var minInput = slider.querySelector('[data-price-input-min]');
      var maxInput = slider.querySelector('[data-price-input-max]');
      if (!minInput || !maxInput) return;
      var vmin = parseFloat(minInput.value);
      var vmax = parseFloat(maxInput.value);
      if (changedSide === 'min') {
        minInput.value = Math.min(vmin, vmax);
      } else {
        maxInput.value = Math.max(vmax, vmin);
      }
    }

    function initPriceSliders(root) {
      var sliders = root.querySelectorAll('[data-price-slider]');
      for (var i = 0; i < sliders.length; i++) {
        updatePriceVisual(sliders[i]);
      }
    }

    // ---- URL construction (slider commit / sort change) ----
    // Starts from current URL so Categoria/Photos filter params (set by chip
    // hrefs via Shopify's value.url_to_add/remove) are preserved, then
    // overrides only the slider params + sort_by.

    function buildUrlFromForm(form, sectionRoot) {
      var baseUrl = sectionRoot.getAttribute('data-section-url') || window.location.pathname;
      var params = new URLSearchParams(window.location.search);

      var sliders = form.querySelectorAll('[data-price-slider]');
      for (var s = 0; s < sliders.length; s++) {
        var slider = sliders[s];
        var minInput = slider.querySelector('[data-price-input-min]');
        var maxInput = slider.querySelector('[data-price-input-max]');
        if (!minInput || !maxInput) continue;
        var vmin = parseFloat(minInput.value);
        var vmax = parseFloat(maxInput.value);
        params.delete('filter.v.price.gte');
        params.delete('filter.v.price.lte');
        params.append('filter.v.price.gte', vmin.toFixed(2));
        params.append('filter.v.price.lte', vmax.toFixed(2));
      }

      var sortDropdown = sectionRoot.querySelector('[data-sort-dropdown]');
      var currentSort = sortDropdown ? sortDropdown.getAttribute('data-sort-current') : '';
      if (currentSort) params.set('sort_by', currentSort);
      else params.delete('sort_by');

      var qs = params.toString();
      return qs ? baseUrl + '?' + qs : baseUrl;
    }

    // ---- AJAX section refresh ----

    function fetchAndReplace(url, sectionRoot, immediate, skipPushState) {
      if (inflightTimer) { clearTimeout(inflightTimer); inflightTimer = null; }
      var delay = immediate ? 0 : 180;
      inflightTimer = setTimeout(function () {
        _doFetchAndReplace(url, sectionRoot, skipPushState);
      }, delay);
    }

    function _doFetchAndReplace(url, sectionRoot, skipPushState) {
      if (!sectionRoot) return;
      var sectionId = sectionRoot.getAttribute('data-section-id');
      if (!sectionId) return;

      if (inflightController) inflightController.abort();
      inflightController = new AbortController();

      // Use ?section_id= (singular, HTML response) — matches Dawn's pattern
      // and works reliably with OS 2.0 template-section IDs on shopify theme dev.
      var fetchUrl = url + (url.indexOf('?') === -1 ? '?' : '&') + 'section_id=' + encodeURIComponent(sectionId);
      sectionRoot.classList.add('categoria-grid--loading');

      fetch(fetchUrl, { headers: { 'Accept': 'text/html' }, signal: inflightController.signal })
        .then(function (res) {
          if (!res.ok) throw new Error('HTTP ' + res.status);
          return res.text();
        })
        .then(function (html) {
          if (!html) throw new Error('Empty Section Rendering API response');
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, 'text/html');
          var newRoot = doc.querySelector('[data-section-id="' + sectionId + '"]');
          if (!newRoot) throw new Error('Section root not found in fetched HTML');
          var newInner = newRoot.querySelector('.categoria-grid__inner');
          var currentInner = sectionRoot.querySelector('.categoria-grid__inner');
          if (!newInner || !currentInner) throw new Error('.categoria-grid__inner wrapper missing');

          var oldToggle = sectionRoot.querySelector('[data-filter-toggle]');
          var wasOpen = oldToggle && oldToggle.getAttribute('aria-expanded') === 'true';

          while (currentInner.firstChild) currentInner.removeChild(currentInner.firstChild);
          while (newInner.firstChild) currentInner.appendChild(newInner.firstChild);

          if (wasOpen) {
            var newToggle = sectionRoot.querySelector('[data-filter-toggle]');
            var newPanel  = sectionRoot.querySelector('[data-filter-panel]');
            if (newToggle) newToggle.setAttribute('aria-expanded', 'true');
            if (newPanel)  newPanel.setAttribute('data-state', 'open');
          }

          initPriceSliders(sectionRoot);
          if (!skipPushState) history.pushState({ catFilter: true }, '', url);
        })
        .catch(function (err) {
          if (err.name === 'AbortError') return;
          console.error('[categoria-product-grid] filter apply failed:', err);
        })
        .finally(function () {
          sectionRoot.classList.remove('categoria-grid--loading');
        });
    }

    // ---- Event delegation ----

    document.addEventListener('click', function (event) {
      // Filter panel toggle
      var toggle = event.target.closest('[data-filter-toggle]');
      if (toggle) {
        var panelId = toggle.getAttribute('aria-controls');
        var panel = panelId ? document.getElementById(panelId) : null;
        var expanded = toggle.getAttribute('aria-expanded') === 'true';
        toggle.setAttribute('aria-expanded', expanded ? 'false' : 'true');
        if (panel) {
          panel.setAttribute('data-state', expanded ? 'closed' : 'open');
          if (!expanded) initPriceSliders(panel);
        }
        return;
      }

      // Filter chip toggle — chip.href is value.url_to_add or value.url_to_remove
      // (computed by Shopify) for list/boolean filters. AJAX the href.
      var chip = event.target.closest('[data-filter-chip]');
      if (chip) {
        if (chip.getAttribute('aria-disabled') === 'true') {
          event.preventDefault();
          return;
        }
        event.preventDefault();
        var pressed = chip.getAttribute('aria-pressed') === 'true';
        chip.setAttribute('aria-pressed', pressed ? 'false' : 'true');
        var sectionRoot = chip.closest('[data-section-id]');
        var chipHref = chip.getAttribute('href');
        if (sectionRoot && chipHref) {
          fetchAndReplace(chipHref, sectionRoot, false);
        }
        return;
      }

      // Active filter chip removal (href = value.url_to_remove)
      var remove = event.target.closest('[data-remove-chip]');
      if (remove) {
        event.preventDefault();
        var sRoot = remove.closest('[data-section-id]');
        fetchAndReplace(remove.getAttribute('href'), sRoot, true);
        return;
      }

      // Clear all
      var clear = event.target.closest('[data-filter-clear]');
      if (clear) {
        event.preventDefault();
        var sR = clear.closest('[data-section-id]');
        fetchAndReplace(clear.getAttribute('href'), sR, true);
        return;
      }

      // Load more
      var loadBtn = event.target.closest('[data-load-more]');
      if (loadBtn && !loadBtn.disabled) {
        event.preventDefault();
        handleLoadMore(loadBtn);
        return;
      }

      // Sort dropdown — toggle trigger
      var sortTrigger = event.target.closest('[data-sort-trigger]');
      if (sortTrigger) {
        var sortDD = sortTrigger.closest('[data-sort-dropdown]');
        var sortList = sortDD.querySelector('[data-sort-list]');
        var isOpen = sortTrigger.getAttribute('aria-expanded') === 'true';
        // Close other open sort dropdowns first
        document.querySelectorAll('[data-sort-trigger][aria-expanded="true"]').forEach(function (t) {
          if (t !== sortTrigger) {
            t.setAttribute('aria-expanded', 'false');
            var l = t.closest('[data-sort-dropdown]').querySelector('[data-sort-list]');
            if (l) l.setAttribute('hidden', '');
          }
        });
        sortTrigger.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
        if (isOpen) sortList.setAttribute('hidden', '');
        else sortList.removeAttribute('hidden');
        return;
      }

      // Sort option selection
      var sortOpt = event.target.closest('[data-sort-option-value]');
      if (sortOpt) {
        var dd = sortOpt.closest('[data-sort-dropdown]');
        var trig = dd.querySelector('[data-sort-trigger]');
        var listEl = dd.querySelector('[data-sort-list]');
        var valEl = dd.querySelector('[data-sort-value]');
        var newVal = sortOpt.getAttribute('data-sort-option-value');

        dd.setAttribute('data-sort-current', newVal);
        if (valEl) valEl.textContent = sortOpt.textContent.trim();
        dd.querySelectorAll('[data-sort-option-value]').forEach(function (o) {
          o.setAttribute('aria-selected', o === sortOpt ? 'true' : 'false');
        });
        if (trig) trig.setAttribute('aria-expanded', 'false');
        if (listEl) listEl.setAttribute('hidden', '');

        var sortSectionRoot = dd.closest('[data-section-id]');
        if (!sortSectionRoot) return;
        var sortPanelForm = sortSectionRoot.querySelector('[data-filter-panel] form');
        var sortUrl;
        if (sortPanelForm) {
          sortUrl = buildUrlFromForm(sortPanelForm, sortSectionRoot);
        } else {
          var sortParams = new URLSearchParams(window.location.search);
          sortParams.set('sort_by', newVal);
          var sortBaseUrl = sortSectionRoot.getAttribute('data-section-url') || window.location.pathname;
          sortUrl = sortBaseUrl + '?' + sortParams.toString();
        }
        fetchAndReplace(sortUrl, sortSectionRoot, true);
        return;
      }

      // Click outside any open sort dropdown closes it
      document.querySelectorAll('[data-sort-trigger][aria-expanded="true"]').forEach(function (t) {
        var d = t.closest('[data-sort-dropdown]');
        if (!d.contains(event.target)) {
          t.setAttribute('aria-expanded', 'false');
          var l = d.querySelector('[data-sort-list]');
          if (l) l.setAttribute('hidden', '');
        }
      });
    });

    // Esc closes any open sort dropdown
    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      document.querySelectorAll('[data-sort-trigger][aria-expanded="true"]').forEach(function (t) {
        t.setAttribute('aria-expanded', 'false');
        var l = t.closest('[data-sort-dropdown]').querySelector('[data-sort-list]');
        if (l) l.setAttribute('hidden', '');
        t.focus();
      });
    });

    document.addEventListener('change', function (event) {
      // Price slider commit (release)
      var priceInput = event.target.closest('[data-price-input-min], [data-price-input-max]');
      if (priceInput) {
        var slider = priceInput.closest('[data-price-slider]');
        var side = priceInput.hasAttribute('data-price-input-min') ? 'min' : 'max';
        clampPrices(slider, side);
        updatePriceVisual(slider);
        var form = priceInput.closest('form');
        var sectionRoot2 = priceInput.closest('[data-section-id]');
        if (form && sectionRoot2) {
          fetchAndReplace(buildUrlFromForm(form, sectionRoot2), sectionRoot2, false);
        }
        return;
      }
    });

    // Live drag — visual only (no fetch)
    document.addEventListener('input', function (event) {
      var priceInput = event.target.closest('[data-price-input-min], [data-price-input-max]');
      if (!priceInput) return;
      var slider = priceInput.closest('[data-price-slider]');
      var side = priceInput.hasAttribute('data-price-input-min') ? 'min' : 'max';
      clampPrices(slider, side);
      updatePriceVisual(slider);
    });

    function handleLoadMore(btn) {
      var nextUrl = btn.dataset.nextUrl;
      var listId  = btn.getAttribute('aria-controls');
      var sectionRoot = btn.closest('[data-section-id]');
      if (!nextUrl || !sectionRoot) return;
      var sectionId = sectionRoot.getAttribute('data-section-id');
      var originalLabel = btn.textContent;
      btn.disabled = true;
      btn.setAttribute('aria-busy', 'true');
      btn.textContent = btn.dataset.loadingLabel || 'Carregando…';
      var fetchUrl = nextUrl + (nextUrl.indexOf('?') === -1 ? '?' : '&') + 'sections=' + encodeURIComponent(sectionId);

      fetch(fetchUrl, { headers: { 'Accept': 'application/json' } })
        .then(function (res) { if (!res.ok) throw new Error('HTTP ' + res.status); return res.json(); })
        .then(function (json) {
          var html = json[sectionId];
          if (!html) throw new Error('Missing section HTML');
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, 'text/html');
          var newList = doc.getElementById(listId);
          var liveList = document.getElementById(listId);
          if (!newList || !liveList) throw new Error('Grid list not found');
          var newItems = Array.prototype.slice.call(newList.children);
          var firstNew = newItems[0] || null;
          newItems.forEach(function (item) { liveList.appendChild(item); });
          var newBtn = doc.querySelector('[data-load-more]');
          if (newBtn) {
            btn.dataset.nextUrl = newBtn.dataset.nextUrl;
            btn.textContent = originalLabel;
            btn.disabled = false;
            btn.removeAttribute('aria-busy');
          } else {
            btn.parentNode.removeChild(btn);
          }
          if (firstNew) {
            var focusTarget = firstNew.querySelector('.card-product__title');
            if (focusTarget) { focusTarget.setAttribute('tabindex', '-1'); focusTarget.focus(); }
          }
        })
        .catch(function (err) {
          console.error('[categoria-product-grid] load-more failed:', err);
          btn.textContent = originalLabel;
          btn.disabled = false;
          btn.removeAttribute('aria-busy');
        });
    }

    // Initial init for any sliders present on first page load
    document.querySelectorAll('[data-section-id]').forEach(function (root) {
      initPriceSliders(root);
    });

    // Browser back/forward — re-sync section with URL
    window.addEventListener('popstate', function () {
      var section = document.querySelector('[data-section-id]');
      if (!section) return;
      // skipPushState=true so we don't push duplicate history entries when the
      // user navigates Back/Forward — popstate itself is the navigation event.
      fetchAndReplace(window.location.pathname + window.location.search, section, true, true);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["como-funciona-faq"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.cffaq').forEach((root) => {
      const items = root.querySelectorAll('.cffaq__item');

      const setOpen = (item, open) => {
        const btn   = item.querySelector('[data-cffaq-toggle]');
        const panel = item.querySelector('.cffaq__answer');
        if (!btn || !panel) return;
        item.classList.toggle('is-open', open);
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        panel.setAttribute('aria-hidden', open ? 'false' : 'true');
        panel.style.maxHeight = open ? panel.scrollHeight + 'px' : '0px';
      };

      items.forEach((item) => {
        const btn = item.querySelector('[data-cffaq-toggle]');
        if (!btn) return;
        btn.addEventListener('click', () => {
          const wasOpen = item.classList.contains('is-open');
          items.forEach((i) => setOpen(i, false));
          if (!wasOpen) setOpen(item, true);
        });
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["como-funciona-steps"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-configurator]').forEach((cfg) => {
    const toggleBtn   = cfg.querySelector('[data-select-toggle]');
    const selectList  = cfg.querySelector('[data-select-list]');
    const selectName  = cfg.querySelector('[data-select-name]');
    const triggerSwatch = toggleBtn.querySelector('.cfstep__cfg-swatch--dyn');
    const preview     = cfg.querySelector('[data-preview]');

    /* ── Cover color dropdown ── */
    toggleBtn.addEventListener('click', () => {
      const open = toggleBtn.getAttribute('aria-expanded') === 'true';
      toggleBtn.setAttribute('aria-expanded', String(!open));
      selectList.hidden = open;
    });

    selectList.querySelectorAll('[data-color-opt]').forEach((opt) => {
      const selectOpt = () => {
        triggerSwatch.style.setProperty('--swatch', opt.dataset.hex);
        triggerSwatch.style.setProperty('--swatch-img', opt.dataset.img ? "url('" + opt.dataset.img + "')" : 'none');
        selectName.textContent = opt.dataset.name;
        preview.style.setProperty('--preview-bg', opt.dataset.hex);
        preview.style.setProperty('--preview-img', opt.dataset.img ? "url('" + opt.dataset.img + "')" : 'none');
        selectList.querySelectorAll('[data-color-opt]').forEach((o) => {
          o.classList.remove('is-selected');
          o.setAttribute('aria-selected', 'false');
        });
        opt.classList.add('is-selected');
        opt.setAttribute('aria-selected', 'true');
        toggleBtn.setAttribute('aria-expanded', 'false');
        selectList.hidden = true;
      };
      opt.addEventListener('click', selectOpt);
      opt.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); selectOpt(); }
      });
    });

    document.addEventListener('click', (e) => {
      if (!cfg.contains(e.target)) {
        toggleBtn.setAttribute('aria-expanded', 'false');
        selectList.hidden = true;
      }
    });

    /* ── Engraving toggle ── */
    const engraveBtns = cfg.querySelectorAll('[data-engrave]');
    engraveBtns.forEach((btn) => {
      btn.addEventListener('click', () => {
        engraveBtns.forEach((b) => b.classList.remove('is-active'));
        btn.classList.add('is-active');
        preview.classList.remove('cfstep__cfg-preview--gold', 'cfstep__cfg-preview--silver');
        preview.classList.add('cfstep__cfg-preview--' + (btn.dataset.foil || 'gold'));
      });
    });

    /* ── Contenteditable placeholder ── */
    cfg.querySelectorAll('[data-placeholder]').forEach((el) => {
      el.addEventListener('focus', () => {
        if (el.textContent.trim() === el.dataset.placeholder) {
          const range = document.createRange();
          range.selectNodeContents(el);
          const sel = window.getSelection();
          sel.removeAllRanges();
          sel.addRange(range);
        }
      });
      el.addEventListener('blur', () => {
        if (el.textContent.trim() === '') {
          el.textContent = el.dataset.placeholder;
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["deadline-popup"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('deadline-popup')) return;

    class DeadlinePopup extends HTMLElement {
      connectedCallback() {
        this.storageKey = 'fn-deadline-popup-' + this.dataset.sectionId;

        /* Oculta linhas cujo prazo (AAAA-MM-DD) já passou. */
        const rows = Array.from(this.querySelectorAll('[data-expires]'));
        const now = new Date();
        rows.forEach((row) => {
          const iso = row.dataset.expires;
          if (!iso) return;
          const limit = new Date(iso + 'T23:59:59');
          if (!isNaN(limit) && now > limit) row.hidden = true;
        });
        this.visibleRows = rows.filter((row) => !row.hidden).length;

        this.querySelectorAll('[data-dp-close]').forEach((el) => {
          el.addEventListener('click', () => this.close());
        });
        document.addEventListener('keydown', (e) => {
          if (e.key === 'Escape') this.close();
        });

        /* Qualquer link terminando em #datas-limite abre o popup (ex.: CTA da barra de avisos). */
        document.addEventListener('click', (e) => {
          const link = e.target.closest && e.target.closest('a[href$="#datas-limite"]');
          if (!link) return;
          e.preventDefault();
          this.open();
        });

        /* No editor de temas, abre ao selecionar a seção. */
        document.addEventListener('shopify:section:select', (e) => {
          if (e.detail && e.detail.sectionId === this.dataset.sectionId) this.open();
        });
        document.addEventListener('shopify:section:deselect', (e) => {
          if (e.detail && e.detail.sectionId === this.dataset.sectionId) this.close();
        });

        /* Exibição automática: 1x a cada N dias, só se houver linha vigente. */
        if (this.dataset.auto === 'true' && this.visibleRows > 0 && this.allowedByFrequency()) {
          setTimeout(() => {
            this.open();
            this.markShown();
          }, parseInt(this.dataset.delay, 10) || 0);
        }
      }

      allowedByFrequency() {
        try {
          const ts = localStorage.getItem(this.storageKey);
          if (!ts) return true;
          const days = parseInt(this.dataset.days, 10) || 3;
          return Date.now() - parseInt(ts, 10) > days * 86400000;
        } catch (err) {
          return true;
        }
      }

      markShown() {
        try {
          localStorage.setItem(this.storageKey, String(Date.now()));
        } catch (err) {
          /* armazenamento indisponível — popup pode reaparecer */
        }
      }

      open() {
        this.classList.add('is-open');
        document.documentElement.style.overflow = 'hidden';
        const closeBtn = this.querySelector('.deadline-popup__close');
        if (closeBtn) closeBtn.focus();
      }

      close() {
        if (!this.classList.contains('is-open')) return;
        this.classList.remove('is-open');
        document.documentElement.style.overflow = '';
      }
    }

    customElements.define('deadline-popup', DeadlinePopup);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-accordion"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.faq-accordion').forEach((root) => {
      const items = root.querySelectorAll('.faq-accordion__item');

      const setOpen = (item, open) => {
        const btn = item.querySelector('[data-faq-toggle]');
        const panel = item.querySelector('.faq-accordion__answer');
        if (!btn || !panel) return;
        item.classList.toggle('is-open', open);
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        panel.setAttribute('aria-hidden', open ? 'false' : 'true');
        // JS-measured target height — animates to actual content size.
        panel.style.maxHeight = open ? panel.scrollHeight + 'px' : '0px';
      };

      items.forEach((item) => {
        const btn = item.querySelector('[data-faq-toggle]');
        if (!btn) return;
        btn.addEventListener('click', () => {
          const wasOpen = item.classList.contains('is-open');
          items.forEach((i) => setOpen(i, false));
          if (!wasOpen) setOpen(item, true);
        });
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-page"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-faq-root]').forEach((root) => {
      initAccordion(root);
      initTabs(root);
      initSidebar(root);
    });

    function initAccordion(root) {
      const items = root.querySelectorAll('.faq-page__item');

      const setOpen = (item, open) => {
        const btn = item.querySelector('[data-faq-toggle]');
        const panel = item.querySelector('.faq-page__answer');
        if (!btn || !panel) return;
        item.classList.toggle('is-open', open);
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        panel.setAttribute('aria-hidden', open ? 'false' : 'true');
        panel.style.maxHeight = open ? panel.scrollHeight + 'px' : '0px';
      };

      items.forEach((item) => {
        const btn = item.querySelector('[data-faq-toggle]');
        if (!btn) return;
        btn.addEventListener('click', () => {
          const wasOpen = item.classList.contains('is-open');
          items.forEach((i) => setOpen(i, false));
          if (!wasOpen) setOpen(item, true);
        });
      });
    }

    function initTabs(root) {
      const tabs = root.querySelectorAll('[data-faq-filter-btn]');
      const categories = root.querySelectorAll('.faq-page__category');
      const tabsContainer = root.querySelector('[data-faq-tabs]');

      const applyFilter = (filterId) => {
        root.setAttribute('data-faq-filter', filterId || '');
        categories.forEach((cat) => {
          if (!filterId || cat.dataset.category === filterId) {
            cat.setAttribute('data-category-active', '');
          } else {
            cat.removeAttribute('data-category-active');
          }
        });
        tabs.forEach((btn) => {
          btn.classList.toggle('is-active', (btn.dataset.faqFilterBtn || '') === (filterId || ''));
        });
      };

      tabs.forEach((btn) => {
        btn.addEventListener('click', () => {
          const filterId = btn.dataset.faqFilterBtn || '';
          applyFilter(filterId);
          if (tabsContainer && window.matchMedia('(max-width: 767px)').matches) {
            tabsContainer.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        });
      });

      applyFilter('');
    }

    function initSidebar(root) {
      const sidebar = root.querySelector('[data-faq-sidebar]');
      if (!sidebar) return;
      const items = sidebar.querySelectorAll('.faq-page__sidebar-item');
      const categories = root.querySelectorAll('.faq-page__category');

      const setActive = (anchorId) => {
        items.forEach((item) => {
          item.classList.toggle('is-active', (item.dataset.faqAnchor || '') === (anchorId || ''));
        });
      };

      sidebar.querySelectorAll('a.faq-page__sidebar-link').forEach((link) => {
        link.addEventListener('click', (e) => {
          e.preventDefault();
          const href = link.getAttribute('href');
          const target = href === '#faq-top'
            ? root.querySelector('#faq-top')
            : root.querySelector(href);
          if (target) {
            target.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        });
      });

      if (!('IntersectionObserver' in window)) return;

      const observer = new IntersectionObserver((entries) => {
        const visible = entries
          .filter((e) => e.isIntersecting)
          .sort((a, b) => a.boundingClientRect.top - b.boundingClientRect.top);
        if (visible.length > 0) {
          setActive(visible[0].target.dataset.category);
        } else if (window.scrollY < (root.offsetTop || 0)) {
          setActive('');
        }
      }, {
        threshold: 0.3,
        rootMargin: '-20% 0px -50% 0px'
      });

      categories.forEach((cat) => observer.observe(cat));
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (() => {
    const header = document.querySelector('.site-header');
    if (!header) return;
    const dialog = header.querySelector('dialog.site-drawer');
    if (!dialog) return;

    const submenuPanels = Array.from(dialog.querySelectorAll('.site-drawer__panel--submenu'));

    const resetPanels = () => {
      submenuPanels.forEach((panel) => {
        panel.classList.remove('is-active');
        panel.hidden = true;
      });
    };

    const openSubmenu = (panelId) => {
      const panel = submenuPanels.find((p) => p.dataset.panel === panelId);
      if (!panel) return;
      panel.hidden = false;
      // Force a reflow so the slide-in transition runs from translateX(100%).
      void panel.offsetWidth;
      panel.classList.add('is-active');
    };

    const closeSubmenu = (panel) => {
      panel.classList.remove('is-active');
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduceMotion) {
        panel.hidden = true;
        return;
      }
      const onEnd = () => {
        panel.hidden = true;
        panel.removeEventListener('transitionend', onEnd);
      };
      panel.addEventListener('transitionend', onEnd);
    };

    header.querySelector('[data-action="open-drawer"]')?.addEventListener('click', () => {
      if (typeof dialog.showModal === 'function') {
        dialog.showModal();
      } else {
        dialog.setAttribute('open', '');
      }
    });

    dialog.querySelector('[data-action="close-drawer"]')?.addEventListener('click', () => {
      dialog.close();
    });

    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) dialog.close();
    });

    dialog.querySelectorAll('[data-open-submenu]').forEach((btn) => {
      btn.addEventListener('click', () => openSubmenu(btn.dataset.openSubmenu));
    });

    dialog.querySelectorAll('[data-close-submenu]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const panel = btn.closest('.site-drawer__panel--submenu');
        if (panel) closeSubmenu(panel);
      });
    });

    dialog.addEventListener('close', resetPanels);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-slideshow"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('hero-slideshow')) return;

    class HeroSlideshow extends HTMLElement {
      connectedCallback() {
        this.slides = Array.from(this.querySelectorAll('.hero-slideshow__slide'));
        if (this.slides.length < 2) return;

        this.dots = Array.from(this.querySelectorAll('[data-dot]'));
        this.fills = this.dots.map((dot) => dot.querySelector('.hero-slideshow__dot-fill'));
        this.pauseBtn = this.querySelector('[data-pause]');
        this.index = 0;
        this.elapsed = 0;
        this.raf = null;
        this.lastTs = null;
        this.userPaused = false;
        this.interval = parseInt(this.dataset.interval, 10) || 5000;
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.autoplay = this.dataset.autoplay === 'true' && !reducedMotion;

        if (!this.autoplay) {
          this.classList.add('hero-slideshow--static');
          if (this.pauseBtn) this.pauseBtn.hidden = true;
        } else if (this.pauseBtn) {
          this.pauseBtn.addEventListener('click', () => this.toggleUserPause());
        }

        const prev = this.querySelector('[data-prev]');
        const next = this.querySelector('[data-next]');
        if (prev) prev.addEventListener('click', () => this.go(this.index - 1, true));
        if (next) next.addEventListener('click', () => this.go(this.index + 1, true));
        this.dots.forEach((dot, i) => dot.addEventListener('click', () => this.go(i, true)));

        this.addEventListener('mouseenter', () => this.stop());
        this.addEventListener('mouseleave', () => this.start());
        this.addEventListener('focusin', () => this.stop());
        this.addEventListener('focusout', () => this.start());
        document.addEventListener('visibilitychange', () => {
          if (document.hidden) this.stop();
          else this.start();
        });

        this.addEventListener('pointerdown', (e) => {
          this.swipeStartX = e.clientX;
        });
        this.addEventListener('pointerup', (e) => {
          if (this.swipeStartX == null) return;
          const delta = e.clientX - this.swipeStartX;
          this.swipeStartX = null;
          if (Math.abs(delta) < 40) return;
          this.go(delta < 0 ? this.index + 1 : this.index - 1, true);
        });

        this.tick = this.tick.bind(this);
        this.go(0);
        this.start();
      }

      /* Relógio único (rAF): preenche a pill ativa e, quando o preenchimento
         completa, avança o slide — timer e troca sempre em sincronia. */
      tick(ts) {
        if (this.lastTs == null) this.lastTs = ts;
        this.elapsed += ts - this.lastTs;
        this.lastTs = ts;

        if (this.elapsed >= this.interval) {
          this.elapsed = 0;
          this.go(this.index + 1);
        }

        const fill = this.fills[this.index];
        if (fill) fill.style.width = Math.min(this.elapsed / this.interval, 1) * 100 + '%';

        this.raf = requestAnimationFrame(this.tick);
      }

      toggleUserPause() {
        this.userPaused = !this.userPaused;
        this.pauseBtn.classList.toggle('is-paused', this.userPaused);
        this.pauseBtn.setAttribute('aria-pressed', this.userPaused ? 'true' : 'false');
        this.pauseBtn.setAttribute(
          'aria-label',
          this.userPaused ? 'Retomar rotação automática' : 'Pausar rotação automática'
        );
        if (this.userPaused) this.stop();
        else this.start();
      }

      go(rawIndex, fromUser) {
        const count = this.slides.length;
        this.index = ((rawIndex % count) + count) % count;

        if (fromUser) this.elapsed = 0;
        this.fills.forEach((fill) => {
          if (fill) fill.style.width = '0%';
        });

        this.slides.forEach((slide, i) => {
          const active = i === this.index;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', active ? 'false' : 'true');
          slide.querySelectorAll('a, button').forEach((el) => {
            if (active) el.removeAttribute('tabindex');
            else el.setAttribute('tabindex', '-1');
          });
          slide.querySelectorAll('video').forEach((video) => {
            if (active) {
              const playing = video.play();
              if (playing && playing.catch) playing.catch(() => {});
            } else {
              video.pause();
            }
          });
        });

        this.dots.forEach((dot, i) => {
          if (i === this.index) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
      }

      start() {
        if (!this.autoplay || this.userPaused || this.raf) return;
        this.lastTs = null;
        this.raf = requestAnimationFrame(this.tick);
      }

      stop() {
        if (!this.raf) return;
        cancelAnimationFrame(this.raf);
        this.raf = null;
      }
    }

    customElements.define('hero-slideshow', HeroSlideshow);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-fotos"]) return;
  try {
    
  (function () {
    var BRL = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' });
    function money(cents) {
      return BRL.format((cents || 0) / 100);
    }

    // Relative luminance → choose a dark check on light swatches, white on dark.
    function isLightHex(hex) {
      if (!hex) return false;
      var h = hex.replace('#', '');
      if (h.length === 3) h = h[0] + h[0] + h[1] + h[1] + h[2] + h[2];
      var r = parseInt(h.substr(0, 2), 16) / 255;
      var g = parseInt(h.substr(2, 2), 16) / 255;
      var b = parseInt(h.substr(4, 2), 16) / 255;
      return (0.2126 * r + 0.7152 * g + 0.0722 * b) > 0.7;
    }

    function initPf(root) {
      if (root.dataset.pfReady) return;
      root.dataset.pfReady = '1';

      // "Ver mais" popup: open by id + close via X / click-outside (same
      // wiring as the album PDP's popups; Esc is native <dialog> behaviour).
      var closePopup = function (dialog) {
        if (typeof dialog.close === 'function') dialog.close();
        else dialog.removeAttribute('open');
      };
      Array.prototype.forEach.call(root.querySelectorAll('[data-popup-open]'), function (opener) {
        opener.addEventListener('click', function () {
          var dialog = document.getElementById(opener.getAttribute('data-popup-open'));
          if (!dialog) return;
          if (typeof dialog.showModal === 'function') dialog.showModal();
          else dialog.setAttribute('open', '');
        });
      });
      Array.prototype.forEach.call(root.querySelectorAll('.pf-popup'), function (dialog) {
        Array.prototype.forEach.call(dialog.querySelectorAll('[data-popup-close]'), function (closer) {
          closer.addEventListener('click', function () { closePopup(dialog); });
        });
        dialog.addEventListener('click', function (event) {
          if (event.target === dialog) closePopup(dialog);
        });
      });

      var dataEl = root.querySelector('.pf-config-data');
      if (!dataEl) return;
      var cfg = JSON.parse(dataEl.textContent);
      var S = cfg.strings;

      var qty = cfg.minQty;
      var border = 'border';
      var boxOn = false;
      var colorIdx = 0;
      var editKey = null;
      var editGroupKeys = [];

      var $ = function (sel) { return root.querySelector(sel); };
      var $all = function (sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); };

      var els = {
        priceNow: $('[data-price-now]'),
        priceWas: $('[data-price-was]'),
        priceOff: $('[data-price-off]'),
        installment: $('[data-price-installment]'),
        pix: $('[data-price-pix]'),
        qtyVal: $('[data-qty-val]'),
        pkgs: $all('[data-pkg]'),
        recapDesc: $('[data-recap-desc]'),
        recapWas: $('[data-recap-was]'),
        recapTotal: $('[data-recap-total]'),
        box: $('[data-box]'),
        boxToggle: $('[data-box-toggle]'),
        boxReadout: $('[data-box-readout]'),
        boxReadoutChip: $('[data-box-readout-chip]'),
        swatches: $all('[data-box-swatch]')
      };

      // Highest discount tier whose quantity threshold is met.
      function activeTier() {
        var best = null;
        (cfg.tiers || []).forEach(function (t) {
          if (qty >= t.q && (!best || t.q > best.q)) best = t;
        });
        return best;
      }

      function selectedSwatch() {
        return els.swatches[colorIdx] || els.swatches[0] || null;
      }

      function render() {
        var tier = activeTier();
        var pct = tier ? tier.p : 0;
        var perPhoto = Math.round(cfg.basePrice * (1 - pct / 100));
        var photosTotal = perPhoto * qty;
        var boxTotal = (boxOn && cfg.box) ? cfg.box.price : 0;
        var total = photosTotal + boxTotal;
        var fullTotal = cfg.basePrice * qty + boxTotal;
        var hasDiscount = pct > 0;

        // Headline price
        if (els.priceNow) els.priceNow.textContent = money(total);
        if (els.priceWas) {
          els.priceWas.textContent = money(fullTotal);
          els.priceWas.hidden = !hasDiscount;
        }
        if (els.priceOff) {
          els.priceOff.textContent = '-' + pct + '%';
          els.priceOff.hidden = !hasDiscount;
        }
        // Installment rule (business rule): max 6× interest-free, with a R$90 minimum
        // per installment. total is in cents, so the R$90 floor = 9000.
        var installmentCount = Math.max(1, Math.min(6, Math.floor(total / 9000)));
        if (els.installment) {
          els.installment.textContent = (S.installmentsTemplate || '{count}× de {price} sem juros')
            .replace('{count}', installmentCount)
            .replace('{price}', money(Math.round(total / installmentCount)));
        }
        if (els.pix) {
          var pixCents = Math.round(total * (1 - (Number(cfg.pixPercent) || 0) / 100));
          els.pix.textContent = (S.pixTemplate || '{price} no Pix').replace('{price}', money(pixCents));
        }

        // Quantity + package highlight
        if (els.qtyVal) els.qtyVal.textContent = qty;
        els.pkgs.forEach(function (b) {
          b.classList.toggle('is-selected', !!tier && Number(b.dataset.qty) === tier.q);
        });

        // Recap
        if (els.recapDesc) {
          // "120x Revelação de Fotos · Caixa Cristal · " (struck price follows inline)
          var desc = qty + 'x ' + S.summaryPrefix;
          if (boxOn && cfg.box) desc += ' · ' + cfg.box.name;
          if (hasDiscount) desc += ' · ';
          els.recapDesc.textContent = desc;
        }
        if (els.recapWas) {
          els.recapWas.textContent = money(fullTotal);
          els.recapWas.hidden = !hasDiscount;
        }
        if (els.recapTotal) els.recapTotal.textContent = money(total);

        // Box card
        if (els.box) els.box.classList.toggle('is-open', boxOn);
        if (els.boxToggle && cfg.box) {
          els.boxToggle.textContent = S.boxCtaPrefix + ' – ' + money(cfg.box.price);
        }
        if (boxOn && cfg.box) updateColorReadout();
        if (boxOn) updateSwatchScroll();
      }

      function updateColorReadout() {
        var sw = selectedSwatch();
        if (!sw) return;
        var hex = sw.dataset.hex;
        var label = sw.dataset.label;
        if (els.boxReadoutChip) els.boxReadoutChip.style.setProperty('--swatch', hex);
        if (els.boxReadout) els.boxReadout.textContent = label + ' – ' + money(cfg.box.price);
        var check = sw.querySelector('.pf-swatch__check');
        if (check) check.style.color = isLightHex(hex) ? '#151616' : '#ffffff';
      }

      // Mobile colour row: always-visible 1px scroll indicator (thumb width + position).
      var swatchScroll = $('[data-box-swatches]');
      var swatchThumb = $('[data-box-scroll-thumb]');
      function updateSwatchScroll() {
        if (!swatchScroll || !swatchThumb) return;
        var scrollable = swatchScroll.scrollWidth > swatchScroll.clientWidth;
        var ratio = scrollable ? swatchScroll.clientWidth / swatchScroll.scrollWidth : 1;
        swatchThumb.style.width = (ratio * 100) + '%';
        swatchThumb.style.left = (scrollable ? (swatchScroll.scrollLeft / swatchScroll.scrollWidth) * 100 : 0) + '%';
      }

      function selectColor(idx) {
        colorIdx = idx;
        els.swatches.forEach(function (s, i) {
          var on = i === idx;
          s.classList.toggle('is-selected', on);
          s.setAttribute('aria-checked', on ? 'true' : 'false');
        });
        updateColorReadout();
      }

      // ── Tamanho (variant) selector — switches everything client-side, no reload ──
      // The server rendered the page for the size it opened on; picking a chip
      // re-points every size-dependent piece (price, minimum, border, box, the
      // freight quote inputs) at the chosen variant. Product-level things
      // (gallery, packages ladder, delivery-deadline banner) are identical
      // across sizes and stay put.
      var sizeButtons = $all('[data-size]');
      var variantsById = {};
      (cfg.variants || []).forEach(function (entry) { variantsById[entry.id] = entry; });

      var sizeBadge = $('[data-size-badge]');
      var minQtyEl = $('[data-min-qty]');
      var borderRule = $('[data-border-rule]');
      var borderField = $('[data-border-field]');
      var boxRule = $('[data-box-rule]');
      var boxField = $('[data-box-field]');
      var prazoHost = root.querySelector('[data-pf-prazo]');

      // Re-point the freight estimator at the new size and drop any quote already
      // on screen — it was priced for the old size. The estimator re-reads its
      // config island on every calculate(), so patching the island is enough for
      // the next quote to be correct; the Expresso row's price is server-rendered
      // (10% of the variant price) so we refresh that node directly.
      function patchPrazo(entry) {
        if (!prazoHost) return;
        var island = prazoHost.querySelector('[data-prazo-config]');
        if (island) {
          try {
            var prazoCfg = JSON.parse(island.textContent);
            prazoCfg.variant = { sku: entry.sku, price: entry.price, weightGrams: entry.weight };
            island.textContent = JSON.stringify(prazoCfg);
          } catch (err) { /* leave the island untouched on parse failure */ }
        }
        var panel = prazoHost.querySelector('[data-prazo-panel]');
        if (panel) panel.hidden = true;
        var prazoError = prazoHost.querySelector('[data-prazo-error]');
        if (prazoError) prazoError.hidden = true;
        var expressoPriceEl = prazoHost.querySelector('[data-prazo-expresso-price]');
        if (expressoPriceEl && entry.expressoPrice) expressoPriceEl.textContent = entry.expressoPrice;
      }

      function applyVariant(entry, isInitial) {
        if (!entry) return;
        cfg.variantId = entry.id;
        cfg.basePrice = entry.price;
        cfg.compareAt = entry.compareAt;
        cfg.minQty = entry.minQty;
        cfg.showBorder = entry.showBorder;
        cfg.sizeLabel = entry.label;
        cfg.box = entry.box;

        // Never sit below the new size's minimum (5x6 needs 45, others 20). Only
        // bump up — a larger quantity the shopper already set stays.
        if (qty < cfg.minQty) qty = cfg.minQty;
        // A size with no box can't keep a box selected.
        if (!cfg.box) boxOn = false;

        sizeButtons.forEach(function (btn) {
          var on = Number(btn.dataset.variantId) === entry.id;
          btn.classList.toggle('is-selected', on);
          btn.setAttribute('aria-checked', on ? 'true' : 'false');
        });
        if (sizeBadge) sizeBadge.textContent = entry.label;
        if (minQtyEl) minQtyEl.textContent = entry.minQty;

        if (borderRule) borderRule.hidden = !entry.showBorder;
        if (borderField) borderField.hidden = !entry.showBorder;

        var showBox = !!entry.box;
        if (boxRule) boxRule.hidden = !showBox;
        if (boxField) boxField.hidden = !showBox;

        patchPrazo(entry);

        // Keep the URL on the chosen size so a refresh or shared link reopens it.
        if (!isInitial && window.history && window.history.replaceState) {
          try {
            var url = new URL(window.location.href);
            url.searchParams.set('variant', entry.id);
            window.history.replaceState({}, '', url);
          } catch (err) { /* older browsers: skip the URL sync, the switch still works */ }
        }

        render();
      }

      sizeButtons.forEach(function (btn) {
        btn.addEventListener('click', function () {
          applyVariant(variantsById[Number(btn.dataset.variantId)], false);
        });
      });

      // ── Events ──
      var dec = $('[data-qty-dec]');
      var inc = $('[data-qty-inc]');
      if (dec) dec.addEventListener('click', function () { qty = Math.max(cfg.minQty, qty - 1); render(); });
      if (inc) inc.addEventListener('click', function () { qty = qty + 1; render(); });

      els.pkgs.forEach(function (b) {
        b.addEventListener('click', function () { qty = Number(b.dataset.qty); render(); });
      });

      $all('[data-border]').forEach(function (b) {
        b.addEventListener('click', function () {
          border = b.dataset.borderVal;
          $all('[data-border]').forEach(function (x) { x.classList.toggle('is-selected', x === b); });
        });
      });

      if (els.boxToggle) {
        els.boxToggle.addEventListener('click', function () { boxOn = true; render(); });
      }
      var boxRemove = $('[data-box-remove]');
      if (boxRemove) boxRemove.addEventListener('click', function () { boxOn = false; render(); });

      els.swatches.forEach(function (s) {
        s.addEventListener('click', function () { selectColor(Number(s.dataset.index)); });
      });

      if (swatchScroll) swatchScroll.addEventListener('scroll', updateSwatchScroll);
      window.addEventListener('resize', updateSwatchScroll);

      var atc = $('[data-atc]');
      var atcLabel = $('[data-atc-label]');
      var atcError = $('[data-atc-error]');
      var defaultAtcLabel = atcLabel ? atcLabel.textContent.trim() : '';
      var adding = false;

      function setAtcError(msg) {
        if (!atcError) return;
        atcError.textContent = msg || '';
        atcError.hidden = !msg;
      }

      if (atc) atc.addEventListener('click', function () {
        if (adding || !cfg.variantId) return;
        qty = Math.max(cfg.minQty, qty);
        adding = true;
        setAtcError('');
        atc.disabled = true;
        if (atcLabel) atcLabel.textContent = S.adding;

        var group = (window.crypto && crypto.randomUUID)
          ? crypto.randomUUID()
          : ('g' + Date.now() + Math.round(Math.random() * 1e6));

        var photoProps = { _group: group, 'Tamanho': cfg.sizeLabel, 'Quantidade': String(qty) };
        if (cfg.showBorder) {
          photoProps['Borda'] = (border === 'border') ? S.borderWith : S.borderWithout;
        }
        var items = [{ id: cfg.variantId, quantity: qty, properties: photoProps }];

        if (boxOn && cfg.box && cfg.box.variantId) {
          var sw = els.swatches[colorIdx];
          items.push({
            id: cfg.box.variantId,
            quantity: 1,
            properties: { _group: group, _addon: 'caixa_cristal', 'Cor da caixa': sw ? sw.getAttribute('data-label') : '' }
          });
        }

        // In edit mode, replace the old group: remove it FIRST so the new fotos line is
        // never a same-variant duplicate of a line still in the cart — Shopify can't
        // disambiguate two same-variant lines by line-item key. Re-read the cart for the
        // current keys (the load-time keys can go stale), then add.
        var removeOld = Promise.resolve();
        if (editKey) {
          removeOld = fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
            .then(function (res) { return res.ok ? res.json() : null; })
            .then(function (cart) {
              var oldKeys = editGroupKeys;
              if (cart) {
                var cartItems = cart.items || [];
                var current = cartItems.find(function (cartItem) { return cartItem.key === editKey; });
                if (current) {
                  var currentGroup = (current.properties || {})._group;
                  oldKeys = currentGroup
                    ? cartItems.filter(function (cartItem) { return (cartItem.properties || {})._group === currentGroup; }).map(function (cartItem) { return cartItem.key; })
                    : [current.key];
                }
              }
              return (oldKeys || []).reduce(function (chain, oldKey) {
                return chain.then(function () {
                  return fetch(cfg.routes.cartChange, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                    body: JSON.stringify({ id: oldKey, quantity: 0, sections: 'cart-drawer', sections_url: window.location.pathname })
                  });
                });
              }, Promise.resolve());
            });
        }

        removeOld.then(function () {
          return fetch(cfg.routes.cartAdd, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: items, sections: 'cart-drawer', sections_url: window.location.pathname })
          });
        }).then(function (res) {
          return res.json().then(function (data) {
            if (!res.ok) {
              setAtcError((data && (data.description || data.message)) || S.addError);
              return;
            }
            document.dispatchEvent(new CustomEvent('cart:open', { detail: { sections: data.sections } }));
          });
        }).catch(function () {
          setAtcError(S.addError);
        }).then(function () {
          adding = false;
          atc.disabled = false;
          if (atcLabel) atcLabel.textContent = defaultAtcLabel;
        });
      });

      var detailsBar = $('[data-details-bar]');
      var detailsBody = $('[data-details-body]');
      var detailsIcon = $('[data-details-icon] svg path');
      if (detailsBar) {
        detailsBar.addEventListener('click', function () {
          var open = detailsBar.getAttribute('aria-expanded') === 'true';
          detailsBar.setAttribute('aria-expanded', open ? 'false' : 'true');
          if (detailsBody) detailsBody.hidden = open;
          if (detailsIcon) detailsIcon.setAttribute('d', open ? 'M12 5v14M5 12h14' : 'M5 12h14');
        });
      }

      // Gallery thumbnails
      var gallery = root.querySelector('[data-pf-gallery]');
      if (gallery) {
        gallery.addEventListener('click', function (e) {
          var thumb = e.target.closest('.pf-gallery__thumb');
          if (!thumb) return;
          var idx = thumb.getAttribute('data-thumb');
          gallery.querySelectorAll('.pf-gallery__thumb').forEach(function (t) {
            t.classList.toggle('is-active', t === thumb);
          });
          gallery.querySelectorAll('.pf-gallery__slide').forEach(function (s) {
            s.classList.toggle('is-active', s.getAttribute('data-slide') === idx);
          });
        });
      }

      if (els.swatches.length) selectColor(0);

      // Edit mode: cart drawer linked here with ?edit=<line_key>. Hide the deadline
      // estimator up front, then hydrate quantity / border / box from that line and its
      // same-group caixa_cristal add-on. Missing/stale line → re-show it, normal view.
      (function initEdit() {
        var key = new URLSearchParams(window.location.search).get('edit');
        if (!key) return;
        var prazoHost = document.querySelector('[data-pf-prazo]');
        if (prazoHost) prazoHost.hidden = true;
        fetch('/cart.js', { headers: { Accept: 'application/json' } })
          .then(function (res) { return res.json(); })
          .then(function (cart) {
            var items = cart.items || [];
            var line = items.find(function (it) { return it.key === key; });
            if (!line) { if (prazoHost) prazoHost.hidden = false; return; }
            var props = line.properties || {};
            var group = props._group;
            editGroupKeys = group
              ? items.filter(function (it) { return (it.properties || {})._group === group; }).map(function (it) { return it.key; })
              : [line.key];
            var parsedQty = parseInt(props['Quantidade'], 10);
            if (parsedQty) qty = Math.max(cfg.minQty, parsedQty);
            if (cfg.showBorder && props['Borda']) {
              border = (props['Borda'] === S.borderWith) ? 'border' : 'none';
              $all('[data-border]').forEach(function (btn) { btn.classList.toggle('is-selected', btn.dataset.borderVal === border); });
            }
            items.forEach(function (it) {
              var addonProps = it.properties || {};
              if (addonProps._group !== group || addonProps._addon !== 'caixa_cristal') return;
              boxOn = true;
              var label = addonProps['Cor da caixa'];
              if (label) {
                els.swatches.forEach(function (swatch, index) {
                  if (swatch.getAttribute('data-label') === label) colorIdx = index;
                });
              }
            });
            editKey = key;
            if (atcLabel) { atcLabel.textContent = S.saveChanges; defaultAtcLabel = S.saveChanges; }
            if (els.swatches.length) selectColor(colorIdx);
            render();
          })
          .catch(function () { if (prazoHost) prazoHost.hidden = false; /* graceful fallback: normal view */ });
      })();

      render();
    }

    function boot() {
      document.querySelectorAll('.pf').forEach(initPf);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-line-grid"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initCarousel(carousel) {
      var track = carousel.querySelector('[data-track]');
      var prev = carousel.querySelector('[data-direction="prev"]');
      var next = carousel.querySelector('[data-direction="next"]');
      if (!track) return;

      function updateState() {
        if (track.clientWidth === 0) return;
        var atStart = track.scrollLeft <= 1;
        var atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 1;
        var hasOverflow = track.scrollWidth > track.clientWidth + 1;
        if (prev) prev.disabled = atStart || !hasOverflow;
        if (next) next.disabled = atEnd || !hasOverflow;
      }

      function scrollByCard(direction) {
        var card = track.querySelector('.card-product');
        if (!card) return;
        var step = card.getBoundingClientRect().width + 21;
        track.scrollBy({ left: direction * step, behavior: 'smooth' });
      }

      if (prev)
        prev.addEventListener('click', function () {
          scrollByCard(-1);
        });
      if (next)
        next.addEventListener('click', function () {
          scrollByCard(1);
        });
      track.addEventListener('scroll', updateState);
      carousel.addEventListener('plg:activated', updateState);
      window.addEventListener('resize', updateState);
      updateState();
    }

    document.querySelectorAll('.product-line-grid').forEach(function (root) {
      var tabs = root.querySelectorAll('[data-tab]');
      var panels = root.querySelectorAll('[data-panel]');

      function activate(targetId) {
        tabs.forEach(function (tab) {
          var isActive = tab.getAttribute('data-tab') === targetId;
          tab.classList.toggle('is-active', isActive);
          tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });
        panels.forEach(function (panel) {
          var isActive = panel.getAttribute('data-panel') === targetId;
          panel.classList.toggle('is-active', isActive);
          panel.hidden = !isActive;
        });
        var activePanel = root.querySelector('[data-panel="' + targetId + '"]');
        var carousel = activePanel && activePanel.querySelector('[data-carousel]');
        if (carousel) carousel.dispatchEvent(new Event('plg:activated'));
      }

      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          activate(tab.getAttribute('data-tab'));
        });
      });

      root.querySelectorAll('[data-carousel]').forEach(initCarousel);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-porta-retrato"]) return;
  try {
    
  (function () {
    const BRL = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' });
    function money(cents) { return BRL.format((cents || 0) / 100); }

    function initPr(root) {
      if (root.dataset.prReady) return;
      root.dataset.prReady = '1';

      const dataEl = root.querySelector('.pr-config-data');
      if (!dataEl) return;
      const cfg = JSON.parse(dataEl.textContent);
      const strings = cfg.strings || {};

      const query = function (selector) { return root.querySelector(selector); };
      const queryAll = function (selector) { return Array.prototype.slice.call(root.querySelectorAll(selector)); };

      let engraveOn = false;
      let photoOn = false;

      const els = {
        priceNow: query('[data-price-now]'),
        priceWas: query('[data-price-was]'),
        priceOff: query('[data-price-off]'),
        installment: query('[data-price-installment]'),
        pix: query('[data-price-pix]'),
        recapDesc: query('[data-recap-desc]'),
        recapTotal: query('[data-recap-total]'),
        colorReadout: query('[data-color-readout]'),
        colorSwatches: queryAll('[data-color-swatch]')
      };

      // ── Headline price (derived from the base variant) ──
      function renderHeadline() {
        const base = cfg.basePrice || 0;
        const compare = cfg.compareAt || 0;
        const hasDiscount = compare > base && compare > 0;
        if (els.priceNow) els.priceNow.textContent = money(base);
        if (els.priceWas) {
          els.priceWas.textContent = money(compare);
          els.priceWas.hidden = !hasDiscount;
        }
        if (els.priceOff) {
          const pct = hasDiscount ? Math.round((1 - base / compare) * 100) : 0;
          els.priceOff.textContent = '-' + pct + '%';
          els.priceOff.hidden = !hasDiscount;
        }
        const count = Math.max(1, Math.min(10, Math.floor(base / 1000)));
        if (els.installment) {
          els.installment.textContent = (strings.installments || '{count}x {price}')
            .replace('{count}', count)
            .replace('{price}', money(Math.round(base / count)));
        }
        if (els.pix) {
          const pixCents = Math.round(base * (1 - (Number(cfg.pixPercent) || 0) / 100));
          els.pix.textContent = (strings.pix || '{price}').replace('{price}', money(pixCents));
        }
      }

      // ── Recap total = base + toggled add-ons (real add-on variant prices) ──
      function recompute() {
        const engravePrice = (cfg.engrave && cfg.engrave.price) || cfg.engraveSurcharge || 0;
        const photoPrice = (cfg.photo && cfg.photo.price) || 0;
        const total = (cfg.basePrice || 0) + (engraveOn ? engravePrice : 0) + (photoOn ? photoPrice : 0);
        if (els.recapDesc) els.recapDesc.textContent = strings.recapPrefix || '';
        if (els.recapTotal) els.recapTotal.textContent = money(total);
      }

      // ── Frame colour ──
      // The colour swatches own their radio state here (they are NOT bound via
      // bindRadioGroup), so is-selected is already flipped to the clicked swatch
      // by the time updatePreview() reads it at the end of this function.
      function selectColor(idx) {
        els.colorSwatches.forEach(function (swatch, index) {
          const on = index === idx;
          swatch.classList.toggle('is-selected', on);
          swatch.setAttribute('aria-checked', on ? 'true' : 'false');
        });
        const chosen = els.colorSwatches[idx];
        if (chosen && els.colorReadout) els.colorReadout.textContent = chosen.getAttribute('data-label') || '';
        updatePreview();
      }
      els.colorSwatches.forEach(function (swatch) {
        swatch.addEventListener('click', function () { selectColor(Number(swatch.getAttribute('data-index'))); });
      });

      // ── Live personalization preview ──
      // Clicking a colour swaps in that colour's frame render ("Em pé" → the
      // vertical shot, "Deitado" → the horizontal one) and, with gravação on,
      // overlays the word in the frame's bottom mat with the chosen foil.
      // Anchors are % / cqw of the shared 1915×1634 studio canvas.
      const PREVIEW_TEXT_POS = {
        h: { x: 50, y: 72.2, size: 2.5 },
        v: { x: 50, y: 80.2, size: 2.5 }
      };
      const previewStage = query('[data-pr-preview]');
      const previewBox = query('[data-pr-preview-box]');
      const previewImg = query('[data-pr-preview-img]');
      const previewText = query('[data-pr-preview-text]');
      let previewLoadToken = 0;

      function currentOrientation() {
        if (engraveOn) {
          const orientEl = query('[data-engrave-orient] .is-selected');
          if (orientEl && orientEl.getAttribute('data-orient') === 'deitado') return 'h';
        }
        return 'v';
      }
      function previewUrl(src) {
        return src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=1400';
      }

      // Pre-warm every colour render once the page has settled, so the first
      // click (and every colour change after it) swaps straight from cache.
      // Vertical first — it's the default orientation — then horizontal; the
      // browser's per-host queue keeps that priority order.
      let previewsWarmed = false;
      function warmPreviews() {
        if (previewsWarmed || !cfg.framePreviews) return;
        previewsWarmed = true;
        ['v', 'h'].forEach(function (orientKey) {
          Object.keys(cfg.framePreviews).forEach(function (label) {
            const entry = cfg.framePreviews[label];
            if (entry && entry[orientKey]) { new Image().src = previewUrl(entry[orientKey]); }
          });
        });
      }
      function scheduleWarmPreviews() {
        const kickoff = function () {
          if (window.requestIdleCallback) requestIdleCallback(warmPreviews, { timeout: 4000 });
          else setTimeout(warmPreviews, 1500);
        };
        if (document.readyState === 'complete') kickoff();
        else window.addEventListener('load', kickoff, { once: true });
      }
      scheduleWarmPreviews();
      function updatePreview() {
        if (!previewStage || !cfg.framePreviews) return;
        const chosen = query('[data-color-swatch].is-selected');
        const label = chosen ? (chosen.getAttribute('data-label') || '') : '';
        const entry = label ? cfg.framePreviews[label] : null;
        const orientKey = currentOrientation();
        const src = entry && entry[orientKey];
        if (!src) {
          // Colour without a render yet (e.g. Preto): fall back to the photo gallery.
          previewStage.hidden = true;
          return;
        }
        const sized = previewUrl(src);
        if (previewImg.getAttribute('src') !== sized) {
          // Decode-then-swap keeps the previous render on screen (no blank flash);
          // the token discards stale loads when colours are clicked in quick succession.
          const token = ++previewLoadToken;
          const loader = new Image();
          loader.onload = function () {
            if (token === previewLoadToken) previewImg.src = sized;
          };
          loader.onerror = function () {
            // Failed load: keep the last good render on screen; with nothing
            // rendered yet, fall back to the photo gallery instead of a broken img.
            if (token === previewLoadToken && !previewImg.getAttribute('src')) previewStage.hidden = true;
          };
          loader.src = sized;
        }
        const other = entry[orientKey === 'v' ? 'h' : 'v'];
        if (other) { new Image().src = previewUrl(other); } // warm the flip side
        previewStage.hidden = false;

        const wordEl = query('[data-engrave-word]');
        const word = wordEl ? wordEl.value.trim() : '';
        const foilEl = query('[data-engrave-color].is-selected');
        const foil = foilEl ? (foilEl.getAttribute('data-foil') || 'silver') : 'silver';
        previewBox.classList.toggle('pr-preview--gold', foil === 'gold');
        previewBox.classList.toggle('pr-preview--silver', foil !== 'gold');
        const pos = PREVIEW_TEXT_POS[orientKey];
        previewText.style.setProperty('--text-x', pos.x + '%');
        previewText.style.setProperty('--text-y', pos.y + '%');
        previewText.style.setProperty('--text-size', pos.size + 'cqw');
        previewText.textContent = word;
        previewText.hidden = !(engraveOn && word);
      }

      // ── Single-select helper for a radiogroup of buttons ──
      function bindRadioGroup(buttons) {
        buttons.forEach(function (button) {
          button.addEventListener('click', function () {
            buttons.forEach(function (other) {
              const on = other === button;
              other.classList.toggle('is-selected', on);
              other.setAttribute('aria-checked', on ? 'true' : 'false');
            });
          });
        });
      }
      bindRadioGroup(queryAll('[data-engrave-color]'));
      bindRadioGroup(queryAll('[data-engrave-orient] [data-orient]'));

      // Preview reacts to every personalization control (after the radio state flips).
      queryAll('[data-engrave-color], [data-engrave-orient] [data-orient]').forEach(function (button) {
        button.addEventListener('click', function () { updatePreview(); });
      });
      const engraveWordInput = query('[data-engrave-word]');
      if (engraveWordInput) engraveWordInput.addEventListener('input', function () { updatePreview(); });

      // ── Production deadline follows the engraving toggle ──
      // The estimator renders with the porta's base days; engraving is produced
      // by another team and stretches production (cfg.prazoDays.engraved, from
      // the gravação product's prazos.config). The estimator recomputes from its
      // JSON config island on every quote, so rewriting the island keeps future
      // quotes correct; the visible produção row and an already-computed total
      // are patched in place.
      const prazoRoot = query('[data-pr-prazo] [data-prazo]');
      function updatePrazoDays() {
        if (!prazoRoot || !cfg.prazoDays) return;
        const days = engraveOn ? cfg.prazoDays.engraved : cfg.prazoDays.base;
        const island = prazoRoot.querySelector('[data-prazo-config]');
        if (!island) return;
        let parsed;
        try { parsed = JSON.parse(island.textContent); } catch (parseError) { return; }
        if (parsed.producao === days) return;
        parsed.producao = days;
        island.textContent = JSON.stringify(parsed);

        const unit = (parsed.strings && parsed.strings.businessDaysUnit) || 'dias úteis';
        const producaoEl = prazoRoot.querySelector('[data-prazo-producao-days]');
        if (producaoEl) producaoEl.textContent = days + ' ' + unit;

        const totalEl = prazoRoot.querySelector('[data-prazo-total-days]');
        if (totalEl && totalEl.textContent.trim()) {
          const deliveryEl = prazoRoot.querySelector('[data-prazo-delivery-days]');
          const deliveryDays = parseInt(deliveryEl && deliveryEl.textContent, 10) || 0;
          totalEl.textContent = ((parsed.diagramacao || 0) + days + deliveryDays) + ' ' + unit;
        }
      }

      // ── Engraving toggle ──
      const engraveToggle = query('[data-engrave-toggle]');
      const engraveFields = query('[data-engrave-fields]');
      if (engraveToggle) {
        engraveToggle.addEventListener('click', function () {
          engraveOn = !engraveOn;
          engraveToggle.setAttribute('aria-checked', engraveOn ? 'true' : 'false');
          engraveToggle.classList.toggle('is-on', engraveOn);
          if (engraveFields) engraveFields.hidden = !engraveOn;
          recompute();
          updatePreview();
          updatePrazoDays();
        });
      }

      // ── Extra-photo toggle (no upload here — the photo is collected after purchase) ──
      const photoToggle = query('[data-photo-toggle]');
      const photoFields = query('[data-photo-fields]');
      if (photoToggle) {
        photoToggle.addEventListener('click', function () {
          photoOn = !photoOn;
          photoToggle.setAttribute('aria-checked', photoOn ? 'true' : 'false');
          photoToggle.classList.toggle('is-on', photoOn);
          if (photoFields) photoFields.hidden = !photoOn;
          recompute();
        });
      }

      // ── Add to cart (real /cart/add.js: main variant + optional gravação add-on line) ──
      // Mirrors sections/product-fotos.liquid: both lines share a `_group` uuid;
      // the gravação line carries `_addon: 'gravacao'` plus its details as
      // line-item properties. The Shopify gravação variant is what charges +R$70.
      const atc = query('[data-atc]');
      const atcNotice = query('[data-atc-notice]');
      const atcLabel = query('[data-atc-label]');
      const defaultAtcLabel = atcLabel ? atcLabel.textContent : '';

      function selectedColorLabel() {
        const chosen = query('[data-color-swatch].is-selected');
        return chosen ? (chosen.getAttribute('data-label') || '') : '';
      }
      function showAtcError(message) {
        if (atcNotice) { atcNotice.textContent = message || ''; atcNotice.hidden = false; }
      }
      function engraveDetails() {
        const wordEl = query('[data-engrave-word]');
        const colorEl = query('[data-engrave-color].is-selected');
        const orientEl = query('[data-engrave-orient] .is-selected');
        return {
          word: wordEl ? wordEl.value.trim() : '',
          color: colorEl ? (colorEl.getAttribute('data-label') || '') : '',
          orient: orientEl ? (orientEl.getAttribute('data-label') || '') : ''
        };
      }

      if (atc && cfg.variantId && cfg.routes && cfg.routes.cartAdd) {
        atc.addEventListener('click', function () {
          // Colour is a real production input (one colour per piece) and nothing is
          // pre-selected — block the add until the customer picks one.
          if (!selectedColorLabel()) {
            showAtcError(strings.chooseColor);
            return;
          }
          const group = (window.crypto && crypto.randomUUID)
            ? crypto.randomUUID()
            : ('g' + Date.now() + Math.round(Math.random() * 1e6));

          const mainProps = { _group: group };
          const colorLabel = selectedColorLabel();
          if (colorLabel) mainProps['Cor da moldura'] = colorLabel;
          // The cart drawer renders _cover_image as the line thumbnail (same
          // contract the Pockets use), so the cart shows the customer's own
          // colour/orientation render instead of the generic product photo.
          if (cfg.framePreviews && colorLabel) {
            const previewEntry = cfg.framePreviews[colorLabel];
            const renderSrc = previewEntry && previewEntry[currentOrientation()];
            if (renderSrc) mainProps['_cover_image'] = renderSrc + (renderSrc.indexOf('?') === -1 ? '?' : '&') + 'width=360';
          }
          const items = [{ id: cfg.variantId, quantity: 1, properties: mainProps }];

          if (engraveOn && cfg.engrave && cfg.engrave.variantId) {
            const details = engraveDetails();
            const engraveProps = { _group: group, _addon: 'gravacao' };
            if (details.word) engraveProps['Gravação'] = details.word;
            if (details.color) engraveProps['Cor do texto'] = details.color;
            if (details.orient) engraveProps['Orientação'] = details.orient;
            items.push({ id: cfg.engrave.variantId, quantity: 1, properties: engraveProps });
          }

          if (photoOn && cfg.photo && cfg.photo.variantId) {
            items.push({ id: cfg.photo.variantId, quantity: 1, properties: { _group: group, _addon: 'foto' } });
          }

          atc.disabled = true;
          if (atcLabel) atcLabel.textContent = strings.adding || defaultAtcLabel;
          if (atcNotice) atcNotice.hidden = true;

          fetch(cfg.routes.cartAdd, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: items, sections: 'cart-drawer', sections_url: window.location.pathname })
          })
            .then(function (response) {
              return response.json().then(function (data) {
                if (!response.ok) {
                  showAtcError((data && (data.description || data.message)) || strings.addError);
                  return;
                }
                // The drawer hydrates itself from the bundled section render and
                // opens via its `cart:open` hook (also refreshes the cart badge).
                document.dispatchEvent(new CustomEvent('cart:open', { detail: { sections: data.sections } }));
              });
            })
            .catch(function () {
              showAtcError(strings.addError);
            })
            .then(function () {
              atc.disabled = false;
              if (atcLabel) atcLabel.textContent = defaultAtcLabel;
            });
        });
      }

      // (Prazo is handled by the shared prazo-estimator snippet, which delegates
      // its own handlers on document — no section JS needed here.)

      // ── Details accordion ──
      const detailsBar = query('[data-details-bar]');
      const detailsBody = query('[data-details-body]');
      const detailsIcon = query('[data-details-icon] svg path');
      if (detailsBar) {
        detailsBar.addEventListener('click', function () {
          const open = detailsBar.getAttribute('aria-expanded') === 'true';
          detailsBar.setAttribute('aria-expanded', open ? 'false' : 'true');
          if (detailsBody) detailsBody.hidden = open;
          if (detailsIcon) detailsIcon.setAttribute('d', open ? 'M12 5v14M5 12h14' : 'M5 12h14');
        });
      }

      // ── Gallery thumbnails ──
      const gallery = query('[data-pr-gallery]');
      if (gallery) {
        gallery.addEventListener('click', function (event) {
          const thumb = event.target.closest('.pf-gallery__thumb');
          if (!thumb) return;
          // Browsing the photos dismisses the personalization preview; any
          // personalization interaction brings it back.
          if (previewStage) previewStage.hidden = true;
          const idx = thumb.getAttribute('data-thumb');
          gallery.querySelectorAll('.pf-gallery__thumb').forEach(function (other) {
            other.classList.toggle('is-active', other === thumb);
          });
          gallery.querySelectorAll('.pf-gallery__slide').forEach(function (slide) {
            slide.classList.toggle('is-active', slide.getAttribute('data-slide') === idx);
          });
        });
      }

      // No initial selectColor: the swatches start unchecked on purpose — the
      // customer's own click is what kicks off the personalization preview.
      renderHeadline();
      recompute();
    }

    function boot() {
      document.querySelectorAll('.pr').forEach(initPr);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reels-carousel"] && !Shopify.designMode) return;
  try {
    
(function () {
  const sections = document.querySelectorAll('.reels-carousel');
  if (sections.length === 0) return;

  const SLOT_CLASSES = [
    'slot-active', 'slot-1-left', 'slot-1-right',
    'slot-2-left', 'slot-2-right', 'slot-3-left', 'slot-3-right',
    'slot-far-left', 'slot-far-right'
  ];

  function getSlotClass(offset) {
    if (offset === 0)  return 'slot-active';
    if (offset === -1) return 'slot-1-left';
    if (offset === 1)  return 'slot-1-right';
    if (offset === -2) return 'slot-2-left';
    if (offset === 2)  return 'slot-2-right';
    if (offset === -3) return 'slot-3-left';
    if (offset === 3)  return 'slot-3-right';
    if (offset < 0)    return 'slot-far-left';
    return 'slot-far-right';
  }

  const isMobile = function () {
    return window.matchMedia('(max-width: 767px)').matches;
  };

  sections.forEach(function (section) {
    const track = section.querySelector('[data-reels-track]');
    if (!track) return;
    const allCards = Array.from(track.querySelectorAll('[data-reel-card]'));
    if (allCards.length === 0) return;
    const originalCards = allCards.filter(function (c) { return !c.hasAttribute('data-duplicate'); });

    const productCard = section.querySelector('[data-reels-product]');
    const productImg = section.querySelector('[data-reels-product-image]');
    const productName = section.querySelector('[data-reels-product-name]');
    const productPrice = section.querySelector('[data-reels-product-price]');
    const prevBtn = section.querySelector('[data-reels-prev]');
    const nextBtn = section.querySelector('[data-reels-next]');

    const productsScript = section.querySelector('[data-reels-products]');
    let products = [];
    try { products = productsScript ? JSON.parse(productsScript.textContent) : []; } catch (_) { products = []; }

    const currency = function (cents) {
      try {
        return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(cents / 100);
      } catch (_) {
        return 'R$ ' + (cents / 100).toFixed(2).replace('.', ',');
      }
    };

    let activeIndex = 0;
    let initialized = false;

    const getCards = function () {
      return isMobile() ? originalCards : allCards;
    };

    const applyLayout = function () {
      const cards = getCards();
      const total = cards.length;

      if (isMobile()) {
        var mTotal = originalCards.length;
        if (mTotal >= 5) {
          // Cyclical: rearrange visible cards by CSS order so active is always at position 1.
          // scrollLeft = MOBILE_STEP then consistently shows active at viewport_x = 20px.
          var prevIdx = ((activeIndex - 1) + mTotal) % mTotal;
          var nextIdx2 = (activeIndex + 1) % mTotal;
          var nextNextIdx = (activeIndex + 2) % mTotal;
          originalCards.forEach(function (card, i) {
            card.classList.remove('is-active', 'is-near');
            SLOT_CLASSES.forEach(function (c) { card.classList.remove(c); });
            if (i === activeIndex) {
              card.classList.add('is-active');
              card.style.order = '1';
              card.style.removeProperty('display');
            } else if (i === prevIdx) {
              card.style.order = '0';
              card.style.removeProperty('display');
            } else if (i === nextIdx2) {
              card.classList.add('is-near');
              card.style.order = '2';
              card.style.removeProperty('display');
            } else if (i === nextNextIdx) {
              card.style.order = '3';
              card.style.removeProperty('display');
            } else {
              card.style.removeProperty('order');
              card.style.display = 'none';
            }
          });
        } else {
          // Non-cyclical: linear layout, no order manipulation.
          originalCards.forEach(function (card, i) {
            card.classList.remove('is-active', 'is-near');
            SLOT_CLASSES.forEach(function (c) { card.classList.remove(c); });
            card.style.removeProperty('order');
            card.style.removeProperty('display');
            var dist = Math.abs(i - activeIndex);
            if (dist === 0) card.classList.add('is-active');
            else if (dist === 1) card.classList.add('is-near');
          });
        }
        return;
      }

      // Desktop: slot-based absolute layout. With duplication, total >= 7 always cyclical.
      const cyclical = total >= 5;
      const halfTotal = total / 2;

      cards.forEach(function (card, i) {
        let offset = i - activeIndex;
        if (cyclical) {
          if (offset > halfTotal) offset -= total;
          else if (offset < -halfTotal) offset += total;
        }
        SLOT_CLASSES.forEach(function (c) { card.classList.remove(c); });
        card.classList.remove('is-near', 'is-active');
        card.classList.toggle('is-active', offset === 0);
        card.classList.add(getSlotClass(offset));
      });
    };

    const updateProductCard = function () {
      const product = products[activeIndex % products.length];
      if (!product || !productCard) return;
      productCard.hidden = false;
      productCard.setAttribute('href', product.url);
      if (productImg) {
        productImg.setAttribute('src', product.image || '');
        productImg.setAttribute('alt', product.title);
      }
      if (productName) productName.textContent = product.title;
      if (productPrice) productPrice.textContent = currency(product.price_min);
    };

    const playActive = function () {
      allCards.forEach(function (card) {
        const video = card.querySelector('[data-reel-video]');
        if (!video) return;
        const cards = getCards();
        const cardIndex = cards.indexOf(card);
        if (cardIndex === activeIndex) {
          const promise = video.play();
          if (promise && typeof promise.then === 'function') {
            promise.catch(function () { /* autoplay blocked */ });
          }
        } else {
          video.pause();
          try { video.currentTime = 0; } catch (_) { /* preload=none seek may throw */ }
        }
      });
    };

    const updateButtons = function () {
      const cards = getCards();
      cards.forEach(function (card, i) {
        const muteBtn = card.querySelector('[data-reels-mute]');
        if (muteBtn) muteBtn.hidden = (i !== activeIndex);
        const playpauseBtn = card.querySelector('[data-reels-playpause]');
        if (playpauseBtn) playpauseBtn.hidden = (i !== activeIndex);
      });
    };

    // Non-active card width (148px) + gap (12px).
    // Cyclical mobile: active is always at order 1 (content_x=180); scrollLeft=160 → viewport_x=20.
    // Non-cyclical mobile: scrollLeft = activeIndex * MOBILE_STEP.
    var MOBILE_STEP = 160; // 148 + 12

    const goTo = function (index) {
      const cards = getCards();
      const total = cards.length;
      if (total >= 5) {
        activeIndex = ((index % total) + total) % total;
      } else {
        activeIndex = Math.max(0, Math.min(total - 1, index));
      }
      applyLayout();
      updateProductCard();
      playActive();
      updateButtons();
      if (prevBtn) prevBtn.hidden = (total < 5 && activeIndex === 0);
      if (nextBtn) nextBtn.hidden = (total < 5 && activeIndex === total - 1);
      if (isMobile()) {
        if (total >= 5) {
          // Cyclical: instant jump so card size CSS transitions provide the visual animation.
          track.scrollLeft = MOBILE_STEP;
        } else {
          track.scrollTo({ left: activeIndex * MOBILE_STEP, behavior: 'smooth' });
        }
      }
    };

    allCards.forEach(function (card) {
      card.addEventListener('click', function (e) {
        if (e.target.closest('[data-reels-mute]') || e.target.closest('[data-reels-playpause]')) return;
        const cards = getCards();
        const idx = cards.indexOf(card);
        if (idx >= 0) goTo(idx);
      });

      const muteBtn = card.querySelector('[data-reels-mute]');
      if (muteBtn) {
        muteBtn.addEventListener('click', function (e) {
          e.stopPropagation();
          const video = card.querySelector('[data-reel-video]');
          if (!video) return;
          video.muted = !video.muted;
          muteBtn.classList.toggle('is-unmuted', !video.muted);
        });
      }

      const playpauseBtn = card.querySelector('[data-reels-playpause]');
      const video = card.querySelector('[data-reel-video]');
      if (playpauseBtn && video) {
        playpauseBtn.addEventListener('click', function (e) {
          e.stopPropagation();
          if (video.paused) video.play();
          else video.pause();
        });
        video.addEventListener('play', function () {
          playpauseBtn.classList.remove('is-paused');
          playpauseBtn.setAttribute('aria-label', playpauseBtn.dataset.labelPause || '');
        });
        video.addEventListener('pause', function () {
          playpauseBtn.classList.add('is-paused');
          playpauseBtn.setAttribute('aria-label', playpauseBtn.dataset.labelPlay || '');
        });
      }
    });

    if (prevBtn) prevBtn.addEventListener('click', function () { goTo(activeIndex - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { goTo(activeIndex + 1); });

    const observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting && !initialized) {
          initialized = true;
          allCards.forEach(function (c) { c.classList.add('no-transition'); });
          goTo(activeIndex);
          void track.offsetWidth;
          allCards.forEach(function (c) { c.classList.remove('no-transition'); });
          track.classList.add('is-ready');
        }
      });
    }, { threshold: 0.25 });
    observer.observe(section);

    // Re-apply layout on viewport resize crossing mobile/desktop breakpoint
    let lastIsMobile = isMobile();
    window.addEventListener('resize', function () {
      const nowMobile = isMobile();
      if (nowMobile !== lastIsMobile) {
        lastIsMobile = nowMobile;
        const cards = getCards();
        if (activeIndex >= cards.length) activeIndex = activeIndex % cards.length;
        applyLayout();
        updateButtons();
        if (nowMobile) {
          track.scrollLeft = originalCards.length >= 5 ? MOBILE_STEP : activeIndex * MOBILE_STEP;
        }
      }
    });

    if (isMobile()) {
      var touchStartX = 0;
      var touchStartY = 0;
      var touchStartScroll = 0;
      var dragCommitted = false; // true once the gesture is confirmed as horizontal

      function lerp(a, b, t) {
        return a + (b - a) * Math.max(0, Math.min(1, t));
      }

      function clearDragState() {
        // Removing --dragging re-enables CSS transitions so the final snap animates.
        section.classList.remove('reels-carousel--dragging');
        originalCards.forEach(function (card) {
          card.style.removeProperty('width');
          card.style.removeProperty('height');
        });
      }

      track.addEventListener('touchstart', function (e) {
        touchStartX = e.touches[0].clientX;
        touchStartY = e.touches[0].clientY;
        touchStartScroll = track.scrollLeft;
        dragCommitted = false;
        section.classList.add('reels-carousel--dragging');
      }, { passive: true });

      track.addEventListener('touchmove', function (e) {
        var dx = touchStartX - e.touches[0].clientX;
        var dy = touchStartY - e.touches[0].clientY;
        var absDx = Math.abs(dx);
        var absDy = Math.abs(dy);

        if (!dragCommitted) {
          // Wait for minimum movement before committing to a direction.
          if (absDx < 6 && absDy < 6) return;
          // Clearly vertical (2:1 ratio) — bail out and let page scroll.
          if (absDy > absDx * 2) {
            section.classList.remove('reels-carousel--dragging');
            return;
          }
          dragCommitted = true;
        }

        e.preventDefault(); // horizontal gesture — take full control

        // 1. Move track in lock-step with the finger.
        track.scrollLeft = touchStartScroll + dx;

        // 2. Interpolate sizes in real time (progress 0→1 over one MOBILE_STEP).
        var progress = absDx / MOBILE_STEP;
        var dir = dx > 0 ? 1 : -1;
        var mLen = originalCards.length;
        var nextIdx = mLen >= 5
          ? ((activeIndex + dir) + mLen) % mLen
          : activeIndex + dir;

        originalCards[activeIndex].style.width  = lerp(200, 148, progress) + 'px';
        originalCards[activeIndex].style.height = lerp(300, 260, progress) + 'px';

        if (mLen >= 5 || (nextIdx >= 0 && nextIdx < mLen)) {
          originalCards[nextIdx].style.width  = lerp(148, 200, progress) + 'px';
          originalCards[nextIdx].style.height = lerp(260, 300, progress) + 'px';
        }
      }, { passive: false });

      track.addEventListener('touchend', function (e) {
        if (!dragCommitted) {
          clearDragState();
          return;
        }

        var dx = touchStartX - e.changedTouches[0].clientX;

        // Re-enable CSS transitions BEFORE goTo() so the snap animates
        // smoothly from the current drag position to the final state.
        clearDragState();

        var snapTarget = originalCards.length >= 5 ? MOBILE_STEP : activeIndex * MOBILE_STEP;
        if (Math.abs(dx) >= MOBILE_STEP * 0.35) {
          goTo(dx > 0 ? activeIndex + 1 : activeIndex - 1);
        } else {
          track.scrollTo({ left: snapTarget, behavior: 'smooth' });
        }
      }, { passive: true });

      track.addEventListener('touchcancel', function () {
        clearDragState();
        var snapTarget = originalCards.length >= 5 ? MOBILE_STEP : activeIndex * MOBILE_STEP;
        track.scrollTo({ left: snapTarget, behavior: 'smooth' });
      }, { passive: true });
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["volume-discount-ladder"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const brlFormatter = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' });
    const formatMoney = (cents) => brlFormatter.format((cents || 0) / 100);
    const newGroupId = () =>
      window.crypto && crypto.randomUUID
        ? crypto.randomUUID()
        : 'pac-' + Date.now() + '-' + Math.round(Math.random() * 1e6);

    document.querySelectorAll('[data-volume-discount]').forEach((root) => {
      const dataElement = root.querySelector('[data-vdl-data]');
      if (!dataElement) return;
      let data;
      try {
        data = JSON.parse(dataElement.textContent);
      } catch (parseError) {
        return;
      }
      const addUrl = root.getAttribute('data-add-url') || '/cart/add.js';
      const strings = data.strings || {};

      // Sizes = variants whose title parses to a photo count > 0, ascending.
      const sizes = (data.variants || [])
        .map((variant) => ({
          id: variant.id,
          photos: parseInt(variant.title, 10),
          price: variant.price,
          available: variant.available,
        }))
        .filter((variant) => variant.photos > 0)
        .sort((sizeA, sizeB) => sizeA.photos - sizeB.photos);
      const isScrapbook = data.isScrapbookHandle || sizes.length < 2;

      const postCart = (items) =>
        fetch(addUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items, sections: 'cart-drawer', sections_url: window.location.pathname }),
        }).then((response) => response.json().then((body) => ({ ok: response.ok, body })));

      const openDrawer = (sections) =>
        document.dispatchEvent(new CustomEvent('cart:open', { detail: { sections } }));

      // ── Scrapbook fast path: N separate qty-1 lines (one per unit) ──
      // Each line needs a UNIQUE _group so Shopify does not merge identical
      // variant+properties lines into one qty-N line; the unique _group also
      // makes the cart drawer render each line stepper-free (remove only). A
      // shared _pacote marks them as one package for fulfillment.
      const addScrapbookPackage = (quantity, button) => {
        if (button.getAttribute('aria-busy') === 'true') return;
        button.setAttribute('aria-busy', 'true');
        const packageId = newGroupId();
        const items = [];
        for (let index = 0; index < quantity; index++) {
          items.push({ id: data.fallbackVariantId, quantity: 1, properties: { _group: newGroupId(), _pacote: packageId } });
        }
        postCart(items)
          .then(({ ok, body }) => {
            if (ok) openDrawer(body.sections);
          })
          .catch(() => {})
          .finally(() => button.removeAttribute('aria-busy'));
      };

      // ── Album modal ──
      const dialog = root.querySelector('[data-vdl-modal]');
      const rowTemplate = root.querySelector('[data-vdl-tpl-row]');
      const pillTemplate = root.querySelector('[data-vdl-tpl-pill]');
      const elements = dialog && {
        title: dialog.querySelector('[data-vdl-title]'),
        subtitle: dialog.querySelector('[data-vdl-sub]'),
        list: dialog.querySelector('[data-vdl-list]'),
        cta: dialog.querySelector('[data-vdl-cta]'),
        priceOriginal: dialog.querySelector('[data-vdl-orig]'),
        priceFinal: dialog.querySelector('[data-vdl-final]'),
        hint: dialog.querySelector('[data-vdl-hint]'),
        error: dialog.querySelector('[data-vdl-error]'),
        close: dialog.querySelector('[data-vdl-close]'),
      };

      let tierQuantity = 0;
      let tierPercentage = 0;
      let selections = [];
      let rows = [];
      let openRowIndex = 0;
      let busy = false;
      let lastFocus = null;

      const openDialog = () => {
        lastFocus = document.activeElement;
        if (typeof dialog.showModal === 'function') dialog.showModal();
        else dialog.setAttribute('open', '');
      };
      const closeDialog = () => {
        if (typeof dialog.close === 'function') dialog.close();
        else dialog.removeAttribute('open');
        if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
      };

      const recalc = () => {
        const chosen = selections.filter(Boolean);
        const originalCents = chosen.reduce((sum, size) => sum + (size.price || 0), 0);
        // Keep the footer prices empty until at least one size is picked, so the
        // disabled CTA doesn't read "R$ 0,00 R$ 0,00".
        if (originalCents > 0) {
          elements.priceOriginal.textContent = formatMoney(originalCents);
          elements.priceFinal.textContent = formatMoney(Math.round(originalCents * (1 - tierPercentage / 100)));
        } else {
          elements.priceOriginal.textContent = '';
          elements.priceFinal.textContent = '';
        }
        const complete = chosen.length === tierQuantity;
        elements.cta.setAttribute('aria-disabled', complete ? 'false' : 'true');
        if (complete) elements.hint.textContent = '';
      };

      const setOpenRow = (rowIndex) => {
        openRowIndex = rowIndex;
        rows.forEach((row, index) => {
          const isOpen = index === openRowIndex;
          row.element.classList.toggle('vdl-modal__row--open', isOpen);
          row.header.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        });
      };

      const paintRow = (index) => {
        const row = rows[index];
        const selection = selections[index];
        row.prefix.textContent = strings.albumLabel + ' ' + (index + 1) + ': ';
        row.value.textContent = selection ? selection.photos + ' ' + strings.photosSuffix : strings.placeholder;
      };

      const selectSize = (index, size, selectedPill) => {
        if (!size.available) return;
        selections[index] = size;
        rows[index].pills.forEach((pill) => {
          const isOn = pill === selectedPill;
          pill.classList.toggle('vdl-modal__pill--on', isOn);
          pill.setAttribute('aria-pressed', isOn ? 'true' : 'false');
        });
        rows[index].element.classList.remove('vdl-modal__row--missing');
        paintRow(index);
        recalc();
        let nextIndex = -1;
        for (let candidate = 0; candidate < tierQuantity; candidate++) {
          if (!selections[candidate]) {
            nextIndex = candidate;
            break;
          }
        }
        setOpenRow(nextIndex);
      };

      const buildRow = (index) => {
        const element = rowTemplate.content.firstElementChild.cloneNode(true);
        const header = element.querySelector('[data-vdl-row-header]');
        const prefix = element.querySelector('[data-vdl-row-prefix]');
        const value = element.querySelector('[data-vdl-row-value]');
        const panel = element.querySelector('[data-vdl-panel]');
        const pills = [];
        sizes.forEach((size) => {
          const pill = pillTemplate.content.firstElementChild.cloneNode(true);
          pill.textContent = size.photos;
          if (!size.available) {
            pill.disabled = true;
            pill.classList.add('vdl-modal__pill--out');
          }
          pill.addEventListener('click', (event) => {
            event.stopPropagation();
            selectSize(index, size, pill);
          });
          panel.appendChild(pill);
          pills.push(pill);
        });
        header.addEventListener('click', () => setOpenRow(openRowIndex === index ? -1 : index));
        rows[index] = { element, header, prefix, value, panel, pills };
        return element;
      };

      const buildModal = (quantity, percentage) => {
        tierQuantity = quantity;
        tierPercentage = percentage;
        selections = new Array(quantity).fill(null);
        rows = new Array(quantity);
        elements.title.textContent = strings.titlePrefix + ' ' + data.productTitle;
        elements.subtitle.textContent = '';
        elements.subtitle.appendChild(document.createTextNode(quantity + ' ' + strings.unitsWord + ' '));
        // Figma colors the whole "12% de desconto" phrase coral, not just the %.
        const percentageSpan = document.createElement('span');
        percentageSpan.className = 'vdl-modal__sub-pct';
        percentageSpan.textContent = percentage + strings.discountSuffix + ' ' + strings.discountWord;
        elements.subtitle.appendChild(percentageSpan);
        elements.list.textContent = '';
        for (let index = 0; index < quantity; index++) {
          elements.list.appendChild(buildRow(index));
          paintRow(index);
        }
        elements.error.textContent = '';
        elements.hint.textContent = '';
        setOpenRow(0);
        recalc();
      };

      const flashMissing = () => {
        elements.hint.textContent = strings.incompleteHint || '';
        rows.forEach((row, index) => {
          if (!selections[index]) {
            row.element.classList.add('vdl-modal__row--missing');
            setTimeout(() => row.element.classList.remove('vdl-modal__row--missing'), 1900);
          }
        });
      };

      const addAlbums = () => {
        if (busy) return;
        if (selections.filter(Boolean).length !== tierQuantity) {
          flashMissing();
          return;
        }
        busy = true;
        elements.cta.setAttribute('aria-busy', 'true');
        elements.error.textContent = '';
        // Unique _group per album → never merged (even when two albums pick the
        // same size/variant) and rendered stepper-free in the drawer; shared
        // _pacote marks the package.
        const packageId = newGroupId();
        const items = selections.map((size) => ({
          id: size.id,
          quantity: 1,
          properties: { _group: newGroupId(), _pacote: packageId, _pacote_size: String(size.photos) },
        }));
        postCart(items)
          .then(({ ok, body }) => {
            if (!ok) {
              elements.error.textContent = (body && (body.description || body.message)) || strings.addError;
              return;
            }
            closeDialog();
            openDrawer(body.sections);
          })
          .catch(() => {
            elements.error.textContent = strings.addError;
          })
          .finally(() => {
            busy = false;
            elements.cta.removeAttribute('aria-busy');
          });
      };

      if (dialog) {
        elements.cta.addEventListener('click', addAlbums);
        elements.close.addEventListener('click', closeDialog);
        dialog.addEventListener('click', (event) => {
          if (event.target === dialog) closeDialog();
        });
      }

      // ── Tier button routing ──
      // Front-first prototype (e.g. porta-retrato): the page is not wired to the
      // cart, so the tier buttons must not POST to /cart/add.js.
      const prototypeMode = root.dataset.prototype === 'true';
      root.querySelectorAll('[data-vdl-add]').forEach((button) => {
        button.addEventListener('click', () => {
          if (prototypeMode) return;
          const quantity = parseInt(button.getAttribute('data-quantity'), 10);
          const percentage = parseInt(button.getAttribute('data-percentage'), 10) || 0;
          if (!quantity) return;
          if (isScrapbook || !dialog) {
            addScrapbookPackage(quantity, button);
          } else {
            buildModal(quantity, percentage);
            openDialog();
          }
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
